// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICardStatusBriefRecordDto,
  ICipConfigMetricsResponseDto,
  ICipInfoMetricsResponseDto,
  ICipStatusBriefDto,
  IClaimActivityBriefDto,
  IClaimDetailsResponseDto,
  IClaimsSubstantiationRateMetricsResponseDto,
  IDelinquentClaimsBriefDto,
  IDelinquentClaimsMetricsResponseDto,
  IEmployeeMetricsResponseDto,
  IEmployerCalendarEventsResponseDto,
  IErrorDto,
  IFraudReviewRequiredMetricsResponseDto,
  IGenericErrorDto,
  IHealthPlanEnrollmentBriefDto,
  IHsaDetailsResponseDto,
  IHsaOverviewResponseDto,
  IHsaPlanBalanceMonthlyBreakdownResponseDto,
  IInvoiceBriefRecordDto,
  IInvoicePlanLevelReplenishmentMetricsResponseDto,
  IInvoiceReplenishmentMetricsResponseDto,
  INotionalDetailsResponseDto,
  INotionalOverviewResponseDto,
  INotionalPlanBalanceMonthlyBreakdownResponseDto,
  IPageReportResultResponseDto,
  IPageReportSchedulerResponseDto,
  IParticipantAccountActivityBriefDto,
  IPlanDto,
  IPlanEnrollmentMetricsResponseDto,
  IPlanResponseDto,
  IPlanYearResponseDto,
  IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto,
  IReportMultiEmployersSummaryPageDtoCipStatusMultiEmployersSummaryRecordDto,
  IReportMultiEmployersSummaryPageDtoClaimActivityMultiEmployersSummaryRecordDto,
  IReportMultiEmployersSummaryPageDtoDelinquentClaimsMultiEmployersSummaryRecordDto,
  IReportMultiEmployersSummaryPageDtoParticipantAccountActivityMultiEmployersSummaryRecordDto,
  IReportMultiEmployersSummaryPageDtoPayrollContributionsMultiEmployersSummaryRecordDto,
  IReportPageDtoBaseBreakdownRecordDto,
  IReportPageDtoCardStatusBreakdownRecordDto,
  IReportPageDtoCipStatusBreakdownRecordDto,
  IReportPageDtoClaimActivityBreakdownRecordDto,
  IReportPageDtoContributionInvoiceBreakdownRecordDto,
  IReportPageDtoEmployeeDemographicsBreakdownRecordDto,
  IReportPageDtoHealthPlanEnrollmentBreakdownRecordDto,
  IReportPageDtoParticipantAccountActivityBreakdownRecordDto,
  IReportPageDtoPayrollContributionsBreakdownRecordDto,
  IReportPageDtoPlanOmnibusBalanceBreakdownRecordDto,
  IReportPageDtoPrefundInvoiceBreakdownRecordDto,
  IReportPageDtoReplenishmentInvoiceBreakdownRecordDto,
  IReportPageDtoUndeliverableAddressBreakdownRecordDto,
  IReportSchedulerCreateDto,
  IReportSchedulerResponseDto,
  IReportSchedulerUpdateDto,
  IReportSummaryPageDtoCardStatusSummaryRecordDto,
  IReportSummaryPageDtoCipStatusSummaryRecordDto,
  IReportSummaryPageDtoClaimActivitySummaryRecordDto,
  IReportSummaryPageDtoDelinquentClaimsSummaryRecordDto,
  IReportSummaryPageDtoForfeitureSummaryRecordDto,
  IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto,
  IReportSummaryPageDtoInvoiceSummaryRecordDto,
  IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto,
  IReportSummaryPageDtoPayrollContributionsSummaryRecordDto,
  IReportSummaryPageDtoPlanOmnibusBalanceSummaryRecordDto,
  ITotalClaimSpendResponseDto,
  IUndeliverableAddressBriefRecordDto,
  IUndeliverableMailMetricsResponseDto,
} from '../models/index';
import {
    ICardStatusBriefRecordDtoFromJSON,
    ICardStatusBriefRecordDtoToJSON,
    ICipConfigMetricsResponseDtoFromJSON,
    ICipConfigMetricsResponseDtoToJSON,
    ICipInfoMetricsResponseDtoFromJSON,
    ICipInfoMetricsResponseDtoToJSON,
    ICipStatusBriefDtoFromJSON,
    ICipStatusBriefDtoToJSON,
    IClaimActivityBriefDtoFromJSON,
    IClaimActivityBriefDtoToJSON,
    IClaimDetailsResponseDtoFromJSON,
    IClaimDetailsResponseDtoToJSON,
    IClaimsSubstantiationRateMetricsResponseDtoFromJSON,
    IClaimsSubstantiationRateMetricsResponseDtoToJSON,
    IDelinquentClaimsBriefDtoFromJSON,
    IDelinquentClaimsBriefDtoToJSON,
    IDelinquentClaimsMetricsResponseDtoFromJSON,
    IDelinquentClaimsMetricsResponseDtoToJSON,
    IEmployeeMetricsResponseDtoFromJSON,
    IEmployeeMetricsResponseDtoToJSON,
    IEmployerCalendarEventsResponseDtoFromJSON,
    IEmployerCalendarEventsResponseDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IFraudReviewRequiredMetricsResponseDtoFromJSON,
    IFraudReviewRequiredMetricsResponseDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IHealthPlanEnrollmentBriefDtoFromJSON,
    IHealthPlanEnrollmentBriefDtoToJSON,
    IHsaDetailsResponseDtoFromJSON,
    IHsaDetailsResponseDtoToJSON,
    IHsaOverviewResponseDtoFromJSON,
    IHsaOverviewResponseDtoToJSON,
    IHsaPlanBalanceMonthlyBreakdownResponseDtoFromJSON,
    IHsaPlanBalanceMonthlyBreakdownResponseDtoToJSON,
    IInvoiceBriefRecordDtoFromJSON,
    IInvoiceBriefRecordDtoToJSON,
    IInvoicePlanLevelReplenishmentMetricsResponseDtoFromJSON,
    IInvoicePlanLevelReplenishmentMetricsResponseDtoToJSON,
    IInvoiceReplenishmentMetricsResponseDtoFromJSON,
    IInvoiceReplenishmentMetricsResponseDtoToJSON,
    INotionalDetailsResponseDtoFromJSON,
    INotionalDetailsResponseDtoToJSON,
    INotionalOverviewResponseDtoFromJSON,
    INotionalOverviewResponseDtoToJSON,
    INotionalPlanBalanceMonthlyBreakdownResponseDtoFromJSON,
    INotionalPlanBalanceMonthlyBreakdownResponseDtoToJSON,
    IPageReportResultResponseDtoFromJSON,
    IPageReportResultResponseDtoToJSON,
    IPageReportSchedulerResponseDtoFromJSON,
    IPageReportSchedulerResponseDtoToJSON,
    IParticipantAccountActivityBriefDtoFromJSON,
    IParticipantAccountActivityBriefDtoToJSON,
    IPlanDtoFromJSON,
    IPlanDtoToJSON,
    IPlanEnrollmentMetricsResponseDtoFromJSON,
    IPlanEnrollmentMetricsResponseDtoToJSON,
    IPlanResponseDtoFromJSON,
    IPlanResponseDtoToJSON,
    IPlanYearResponseDtoFromJSON,
    IPlanYearResponseDtoToJSON,
    IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDtoFromJSON,
    IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDtoToJSON,
    IReportMultiEmployersSummaryPageDtoCipStatusMultiEmployersSummaryRecordDtoFromJSON,
    IReportMultiEmployersSummaryPageDtoCipStatusMultiEmployersSummaryRecordDtoToJSON,
    IReportMultiEmployersSummaryPageDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSON,
    IReportMultiEmployersSummaryPageDtoClaimActivityMultiEmployersSummaryRecordDtoToJSON,
    IReportMultiEmployersSummaryPageDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON,
    IReportMultiEmployersSummaryPageDtoDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON,
    IReportMultiEmployersSummaryPageDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON,
    IReportMultiEmployersSummaryPageDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON,
    IReportMultiEmployersSummaryPageDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON,
    IReportMultiEmployersSummaryPageDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSON,
    IReportPageDtoBaseBreakdownRecordDtoFromJSON,
    IReportPageDtoBaseBreakdownRecordDtoToJSON,
    IReportPageDtoCardStatusBreakdownRecordDtoFromJSON,
    IReportPageDtoCardStatusBreakdownRecordDtoToJSON,
    IReportPageDtoCipStatusBreakdownRecordDtoFromJSON,
    IReportPageDtoCipStatusBreakdownRecordDtoToJSON,
    IReportPageDtoClaimActivityBreakdownRecordDtoFromJSON,
    IReportPageDtoClaimActivityBreakdownRecordDtoToJSON,
    IReportPageDtoContributionInvoiceBreakdownRecordDtoFromJSON,
    IReportPageDtoContributionInvoiceBreakdownRecordDtoToJSON,
    IReportPageDtoEmployeeDemographicsBreakdownRecordDtoFromJSON,
    IReportPageDtoEmployeeDemographicsBreakdownRecordDtoToJSON,
    IReportPageDtoHealthPlanEnrollmentBreakdownRecordDtoFromJSON,
    IReportPageDtoHealthPlanEnrollmentBreakdownRecordDtoToJSON,
    IReportPageDtoParticipantAccountActivityBreakdownRecordDtoFromJSON,
    IReportPageDtoParticipantAccountActivityBreakdownRecordDtoToJSON,
    IReportPageDtoPayrollContributionsBreakdownRecordDtoFromJSON,
    IReportPageDtoPayrollContributionsBreakdownRecordDtoToJSON,
    IReportPageDtoPlanOmnibusBalanceBreakdownRecordDtoFromJSON,
    IReportPageDtoPlanOmnibusBalanceBreakdownRecordDtoToJSON,
    IReportPageDtoPrefundInvoiceBreakdownRecordDtoFromJSON,
    IReportPageDtoPrefundInvoiceBreakdownRecordDtoToJSON,
    IReportPageDtoReplenishmentInvoiceBreakdownRecordDtoFromJSON,
    IReportPageDtoReplenishmentInvoiceBreakdownRecordDtoToJSON,
    IReportPageDtoUndeliverableAddressBreakdownRecordDtoFromJSON,
    IReportPageDtoUndeliverableAddressBreakdownRecordDtoToJSON,
    IReportSchedulerCreateDtoFromJSON,
    IReportSchedulerCreateDtoToJSON,
    IReportSchedulerResponseDtoFromJSON,
    IReportSchedulerResponseDtoToJSON,
    IReportSchedulerUpdateDtoFromJSON,
    IReportSchedulerUpdateDtoToJSON,
    IReportSummaryPageDtoCardStatusSummaryRecordDtoFromJSON,
    IReportSummaryPageDtoCardStatusSummaryRecordDtoToJSON,
    IReportSummaryPageDtoCipStatusSummaryRecordDtoFromJSON,
    IReportSummaryPageDtoCipStatusSummaryRecordDtoToJSON,
    IReportSummaryPageDtoClaimActivitySummaryRecordDtoFromJSON,
    IReportSummaryPageDtoClaimActivitySummaryRecordDtoToJSON,
    IReportSummaryPageDtoDelinquentClaimsSummaryRecordDtoFromJSON,
    IReportSummaryPageDtoDelinquentClaimsSummaryRecordDtoToJSON,
    IReportSummaryPageDtoForfeitureSummaryRecordDtoFromJSON,
    IReportSummaryPageDtoForfeitureSummaryRecordDtoToJSON,
    IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDtoFromJSON,
    IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDtoToJSON,
    IReportSummaryPageDtoInvoiceSummaryRecordDtoFromJSON,
    IReportSummaryPageDtoInvoiceSummaryRecordDtoToJSON,
    IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDtoFromJSON,
    IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDtoToJSON,
    IReportSummaryPageDtoPayrollContributionsSummaryRecordDtoFromJSON,
    IReportSummaryPageDtoPayrollContributionsSummaryRecordDtoToJSON,
    IReportSummaryPageDtoPlanOmnibusBalanceSummaryRecordDtoFromJSON,
    IReportSummaryPageDtoPlanOmnibusBalanceSummaryRecordDtoToJSON,
    ITotalClaimSpendResponseDtoFromJSON,
    ITotalClaimSpendResponseDtoToJSON,
    IUndeliverableAddressBriefRecordDtoFromJSON,
    IUndeliverableAddressBriefRecordDtoToJSON,
    IUndeliverableMailMetricsResponseDtoFromJSON,
    IUndeliverableMailMetricsResponseDtoToJSON,
} from '../models/index';

export interface CreateReportSchedulerRequest {
    iReportSchedulerCreateDto: IReportSchedulerCreateDto;
}

export interface DeactivateReportSchedulerRequest {
    id: number;
}

export interface DeleteReportResultRequest {
    id: number;
}

export interface GetAccountUsagePlanYearsRequest {
    observedOrganizationPath?: string;
}

export interface GetCardStatusMultiEmployerSummaryRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    cardStatusReportGroupType?: GetCardStatusMultiEmployerSummaryCardStatusReportGroupTypeEnum;
    page?: number;
    size?: number;
}

export interface GetCardStatusMultiEmployerSummaryCsvRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    cardStatusReportGroupType?: GetCardStatusMultiEmployerSummaryCsvCardStatusReportGroupTypeEnum;
}

export interface GetCardStatusReportBreakdownRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    isNotMailed?: boolean;
    mailedStartDate?: Date;
    mailedEndDate?: Date;
    cardStatuses?: Set<GetCardStatusReportBreakdownCardStatusesEnum>;
    employmentStatuses?: Set<GetCardStatusReportBreakdownEmploymentStatusesEnum>;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetCardStatusReportBreakdownCsvRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    isNotMailed?: boolean;
    mailedStartDate?: Date;
    mailedEndDate?: Date;
    cardStatuses?: Set<GetCardStatusReportBreakdownCsvCardStatusesEnum>;
    employmentStatuses?: Set<GetCardStatusReportBreakdownCsvEmploymentStatusesEnum>;
    showSsn?: boolean;
}

export interface GetCardStatusReportBriefRequest {
    observedOrganizationPath?: string;
}

export interface GetCardStatusReportSummaryRequest {
    employerId: number;
    cardStatusReportGroupType?: GetCardStatusReportSummaryCardStatusReportGroupTypeEnum;
    page?: number;
    size?: number;
}

export interface GetCardStatusReportSummaryCsvRequest {
    employerId: number;
    cardStatusReportGroupType?: GetCardStatusReportSummaryCsvCardStatusReportGroupTypeEnum;
}

export interface GetCipConfigMetricsRequest {
    observedOrganizationPath?: string;
}

export interface GetCipInfoMetricsRequest {
    observedOrganizationPath?: string;
}

export interface GetCipStatusReportBreakdownRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    cipStatusStartDate?: Date;
    cipStatusEndDate?: Date;
    employmentStatuses?: Set<GetCipStatusReportBreakdownEmploymentStatusesEnum>;
    accountStatuses?: Set<GetCipStatusReportBreakdownAccountStatusesEnum>;
    enrollmentStatuses?: Set<GetCipStatusReportBreakdownEnrollmentStatusesEnum>;
    cipStatuses?: Set<GetCipStatusReportBreakdownCipStatusesEnum>;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetCipStatusReportBreakdownCsvRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    cipStatusStartDate?: Date;
    cipStatusEndDate?: Date;
    employmentStatuses?: Set<GetCipStatusReportBreakdownCsvEmploymentStatusesEnum>;
    accountStatuses?: Set<GetCipStatusReportBreakdownCsvAccountStatusesEnum>;
    enrollmentStatuses?: Set<GetCipStatusReportBreakdownCsvEnrollmentStatusesEnum>;
    cipStatuses?: Set<GetCipStatusReportBreakdownCsvCipStatusesEnum>;
    showSsn?: boolean;
}

export interface GetCipStatusReportBriefRequest {
    observedOrganizationPath?: string;
}

export interface GetCipStatusReportMultiEmployersSummaryCsvRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
}

export interface GetCipStatusReportSummaryRequest {
    employerId: number;
    page?: number;
    size?: number;
}

export interface GetCipStatusReportSummaryCsvRequest {
    employerId: number;
}

export interface GetClaimActivityMultiEmployerSummaryRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    claimStatuses?: Set<GetClaimActivityMultiEmployerSummaryClaimStatusesEnum>;
    claimTypes?: Set<GetClaimActivityMultiEmployerSummaryClaimTypesEnum>;
    page?: number;
    size?: number;
}

export interface GetClaimActivityMultiEmployerSummaryCsvRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    claimStatuses?: Set<GetClaimActivityMultiEmployerSummaryCsvClaimStatusesEnum>;
    claimTypes?: Set<GetClaimActivityMultiEmployerSummaryCsvClaimTypesEnum>;
}

export interface GetClaimActivityReportBreakdownRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    claimSubmitStartDate?: Date;
    claimSubmitEndDate?: Date;
    claimPaidStartDate?: Date;
    claimPaidEndDate?: Date;
    claimTypes?: Set<GetClaimActivityReportBreakdownClaimTypesEnum>;
    claimStatuses?: Set<GetClaimActivityReportBreakdownClaimStatusesEnum>;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetClaimActivityReportBreakdownCsvRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    claimSubmitStartDate?: Date;
    claimSubmitEndDate?: Date;
    claimPaidStartDate?: Date;
    claimPaidEndDate?: Date;
    claimTypes?: Set<GetClaimActivityReportBreakdownCsvClaimTypesEnum>;
    claimStatuses?: Set<GetClaimActivityReportBreakdownCsvClaimStatusesEnum>;
    showSsn?: boolean;
}

export interface GetClaimActivityReportBriefRequest {
    observedOrganizationPath?: string;
}

export interface GetClaimActivityReportSummaryRequest {
    employerId: number;
    claimStatuses?: Set<GetClaimActivityReportSummaryClaimStatusesEnum>;
    claimTypes?: Set<GetClaimActivityReportSummaryClaimTypesEnum>;
    page?: number;
    size?: number;
}

export interface GetClaimActivityReportSummaryCsvRequest {
    employerId: number;
    claimStatuses?: Set<GetClaimActivityReportSummaryCsvClaimStatusesEnum>;
    claimTypes?: Set<GetClaimActivityReportSummaryCsvClaimTypesEnum>;
}

export interface GetClaimDetailsRequest {
    planId: number;
    observedOrganizationPath?: string;
}

export interface GetClaimsSubstantiationRateMetricsRequest {
    observedOrganizationPath?: string;
}

export interface GetContributionInvoiceReportBreakdownRequest {
    employerId: number;
    searchValue?: string;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetContributionInvoiceReportBreakdownCsvRequest {
    employerId: number;
    searchValue?: string;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
    showSsn?: boolean;
}

export interface GetContributionInvoiceReportBriefRequest {
    observedOrganizationPath?: string;
}

export interface GetContributionInvoiceReportSummaryRequest {
    employerId: number;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
    page?: number;
    size?: number;
}

export interface GetContributionInvoiceReportSummaryCsvRequest {
    employerId: number;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
}

export interface GetDelinquentClaimsMetricsRequest {
    observedOrganizationPath?: string;
}

export interface GetDelinquentClaimsMultiEmployerSummaryRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    accountTypes?: Set<GetDelinquentClaimsMultiEmployerSummaryAccountTypesEnum>;
    planYearPeriod?: Set<GetDelinquentClaimsMultiEmployerSummaryPlanYearPeriodEnum>;
    page?: number;
    size?: number;
}

export interface GetDelinquentClaimsMultiEmployerSummaryCsvRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    accountTypes?: Set<GetDelinquentClaimsMultiEmployerSummaryCsvAccountTypesEnum>;
    planYearPeriod?: Set<GetDelinquentClaimsMultiEmployerSummaryCsvPlanYearPeriodEnum>;
}

export interface GetDelinquentClaimsReportBreakdownRequest {
    delinquentClaimsViewType: GetDelinquentClaimsReportBreakdownDelinquentClaimsViewTypeEnum;
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    planIds?: Set<number>;
    planYearPeriods?: Set<GetDelinquentClaimsReportBreakdownPlanYearPeriodsEnum>;
    accountTypes?: Set<GetDelinquentClaimsReportBreakdownAccountTypesEnum>;
    claimStatuses?: Set<GetDelinquentClaimsReportBreakdownClaimStatusesEnum>;
    searchValue?: string;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetDelinquentClaimsReportBreakdownCsvRequest {
    delinquentClaimsViewType: GetDelinquentClaimsReportBreakdownCsvDelinquentClaimsViewTypeEnum;
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    planIds?: Set<number>;
    planYearPeriods?: Set<GetDelinquentClaimsReportBreakdownCsvPlanYearPeriodsEnum>;
    accountTypes?: Set<GetDelinquentClaimsReportBreakdownCsvAccountTypesEnum>;
    claimStatuses?: Set<GetDelinquentClaimsReportBreakdownCsvClaimStatusesEnum>;
    searchValue?: string;
    showSsn?: boolean;
}

export interface GetDelinquentClaimsReportBriefRequest {
    observedOrganizationPath?: string;
    page?: number;
    size?: number;
}

export interface GetDelinquentClaimsReportSummaryRequest {
    employerId: number;
    observedOrganizationPath?: string;
    planIds?: Set<number>;
    planYearPeriod?: Set<GetDelinquentClaimsReportSummaryPlanYearPeriodEnum>;
    accountTypes?: Set<GetDelinquentClaimsReportSummaryAccountTypesEnum>;
    page?: number;
    size?: number;
}

export interface GetDelinquentClaimsReportSummaryCsvRequest {
    employerId: number;
    observedOrganizationPath?: string;
    planIds?: Set<number>;
    planYearPeriod?: Set<GetDelinquentClaimsReportSummaryCsvPlanYearPeriodEnum>;
    accountTypes?: Set<GetDelinquentClaimsReportSummaryCsvAccountTypesEnum>;
}

export interface GetEmployeeDemographicsReportBreakdownRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    employmentStatuses?: Set<GetEmployeeDemographicsReportBreakdownEmploymentStatusesEnum>;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetEmployeeDemographicsReportBreakdownCsvRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    employmentStatuses?: Set<GetEmployeeDemographicsReportBreakdownCsvEmploymentStatusesEnum>;
    showSsn?: boolean;
}

export interface GetEmployerCalendarEventsRequest {
    observedOrganizationPath?: string;
    fromDate?: Date;
    toDate?: Date;
    categories?: Array<GetEmployerCalendarEventsCategoriesEnum>;
}

export interface GetForfeitureReportBreakdownRequest {
    employerId: number;
    forfeitureReportGroup: GetForfeitureReportBreakdownForfeitureReportGroupEnum;
    searchValue?: string;
    planYearPeriod?: Set<GetForfeitureReportBreakdownPlanYearPeriodEnum>;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetForfeitureReportBreakdownCsvRequest {
    employerId: number;
    forfeitureReportGroup: GetForfeitureReportBreakdownCsvForfeitureReportGroupEnum;
    searchValue?: string;
    planYearPeriod?: Set<GetForfeitureReportBreakdownCsvPlanYearPeriodEnum>;
    showSsn?: boolean;
}

export interface GetForfeitureReportSummaryRequest {
    employerId: number;
    planYearPeriod?: Set<GetForfeitureReportSummaryPlanYearPeriodEnum>;
    page?: number;
    size?: number;
}

export interface GetForfeitureReportSummaryCsvRequest {
    employerId: number;
    planYearPeriod?: Set<GetForfeitureReportSummaryCsvPlanYearPeriodEnum>;
}

export interface GetFraudReviewRequiredMetricsRequest {
    observedOrganizationPath?: string;
}

export interface GetHealthPlanEnrollmentReportBreakdownRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    planIds?: Set<number>;
    searchValue?: string;
    planYearPeriod?: Set<GetHealthPlanEnrollmentReportBreakdownPlanYearPeriodEnum>;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetHealthPlanEnrollmentReportBreakdownCsvRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    planIds?: Set<number>;
    searchValue?: string;
    planYearPeriod?: Set<GetHealthPlanEnrollmentReportBreakdownCsvPlanYearPeriodEnum>;
    showSsn?: boolean;
}

export interface GetHealthPlanEnrollmentReportBriefRequest {
    observedOrganizationPath?: string;
}

export interface GetHealthPlanEnrollmentReportSummaryRequest {
    employerId: number;
    planYearPeriod?: Set<GetHealthPlanEnrollmentReportSummaryPlanYearPeriodEnum>;
    page?: number;
    size?: number;
}

export interface GetHealthPlanEnrollmentReportSummaryCsvRequest {
    employerId: number;
    planYearPeriod?: Set<GetHealthPlanEnrollmentReportSummaryCsvPlanYearPeriodEnum>;
}

export interface GetHsaBalancesRequest {
    planId: number;
    observedOrganizationPath?: string;
}

export interface GetHsaOverviewRequest {
    planId: number;
    observedOrganizationPath?: string;
}

export interface GetHsaPlanDetailsRequest {
    planId: number;
    observedOrganizationPath?: string;
}

export interface GetInvoicePlanLevelReplenishmentMetricsRequest {
    startDate: Date;
    endDate: Date;
    observedOrganizationPath?: string;
}

export interface GetInvoiceReplenishmentMetricsRequest {
    startDate: Date;
    endDate: Date;
    observedOrganizationPath?: string;
}

export interface GetNotionalOverviewRequest {
    planId: number;
    observedOrganizationPath?: string;
}

export interface GetNotionalPlanDetailsRequest {
    planId: number;
    observedOrganizationPath?: string;
}

export interface GetPaaMultiEmployerSummaryRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    planYearPeriod?: Set<GetPaaMultiEmployerSummaryPlanYearPeriodEnum>;
    page?: number;
    size?: number;
}

export interface GetPaaMultiEmployerSummaryCsvRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    planYearPeriod?: Set<GetPaaMultiEmployerSummaryCsvPlanYearPeriodEnum>;
}

export interface GetParticipantAccountActivityReportBreakdownRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    planIds?: Set<number>;
    asOfDate?: Date;
    searchValue?: string;
    planYearPeriod?: Set<GetParticipantAccountActivityReportBreakdownPlanYearPeriodEnum>;
    enrollmentStatuses?: Set<GetParticipantAccountActivityReportBreakdownEnrollmentStatusesEnum>;
    showSsn?: boolean;
    accountTypes?: Set<GetParticipantAccountActivityReportBreakdownAccountTypesEnum>;
    page?: number;
    size?: number;
}

export interface GetParticipantAccountActivityReportBreakdownCsvRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    planIds?: Set<number>;
    asOfDate?: Date;
    searchValue?: string;
    planYearPeriod?: Set<GetParticipantAccountActivityReportBreakdownCsvPlanYearPeriodEnum>;
    enrollmentStatuses?: Set<GetParticipantAccountActivityReportBreakdownCsvEnrollmentStatusesEnum>;
    showSsn?: boolean;
    accountTypes?: Set<GetParticipantAccountActivityReportBreakdownCsvAccountTypesEnum>;
}

export interface GetParticipantAccountActivityReportBriefRequest {
    observedOrganizationPath?: string;
}

export interface GetParticipantAccountActivityReportSummaryRequest {
    employerId: number;
    planIds?: Set<number>;
    planYearPeriod?: Set<GetParticipantAccountActivityReportSummaryPlanYearPeriodEnum>;
    page?: number;
    size?: number;
}

export interface GetParticipantAccountActivityReportSummaryCsvRequest {
    employerId: number;
    planIds?: Set<number>;
    planYearPeriod?: Set<GetParticipantAccountActivityReportSummaryCsvPlanYearPeriodEnum>;
}

export interface GetPayrollContributionsMultiEmployerSummaryRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    planYearPeriod?: Set<GetPayrollContributionsMultiEmployerSummaryPlanYearPeriodEnum>;
    page?: number;
    size?: number;
}

export interface GetPayrollContributionsMultiEmployerSummaryCsvRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    planYearPeriod?: Set<GetPayrollContributionsMultiEmployerSummaryCsvPlanYearPeriodEnum>;
}

export interface GetPayrollContributionsReportBreakdownRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    planIds?: Set<number>;
    contributionStartDate?: Date;
    contributionEndDate?: Date;
    transactionStartDate?: Date;
    transactionEndDate?: Date;
    searchValue?: string;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetPayrollContributionsReportBreakdownCsvRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    planIds?: Set<number>;
    contributionStartDate?: Date;
    contributionEndDate?: Date;
    transactionStartDate?: Date;
    transactionEndDate?: Date;
    searchValue?: string;
    showSsn?: boolean;
}

export interface GetPayrollContributionsReportSummaryRequest {
    employerId: number;
    planIds?: Set<number>;
    planYearPeriod?: Set<GetPayrollContributionsReportSummaryPlanYearPeriodEnum>;
    page?: number;
    size?: number;
}

export interface GetPayrollContributionsReportSummaryCsvRequest {
    employerId: number;
    planIds?: Set<number>;
    planYearPeriod?: Set<GetPayrollContributionsReportSummaryCsvPlanYearPeriodEnum>;
}

export interface GetPlanEnrollmentMetricsRequest {
    observedOrganizationPath?: string;
}

export interface GetPlanOmnibusBalanceReportBreakdownRequest {
    employerId: number;
    planIds: Set<number>;
    searchValue?: string;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetPlanOmnibusBalanceReportBreakdownCsvRequest {
    employerId: number;
    planIds: Set<number>;
    searchValue?: string;
    showSsn?: boolean;
}

export interface GetPlanOmnibusBalanceReportBreakdownPlansRequest {
    employerId: number;
}

export interface GetPlanOmnibusBalanceReportSummaryRequest {
    employerId: number;
    planIds?: Set<number>;
    planYearPeriod?: Set<GetPlanOmnibusBalanceReportSummaryPlanYearPeriodEnum>;
    page?: number;
    size?: number;
}

export interface GetPlanOmnibusBalanceReportSummaryCsvRequest {
    employerId: number;
    planIds?: Set<number>;
    planYearPeriod?: Set<GetPlanOmnibusBalanceReportSummaryCsvPlanYearPeriodEnum>;
}

export interface GetPlansRequest {
    observedOrganizationPath?: string;
    searchValue?: string;
}

export interface GetPrefundInvoiceReportBreakdownRequest {
    employerId: number;
    searchValue?: string;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetPrefundInvoiceReportBreakdownCsvRequest {
    employerId: number;
    searchValue?: string;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
    showSsn?: boolean;
}

export interface GetPrefundInvoiceReportBriefRequest {
    observedOrganizationPath?: string;
}

export interface GetPrefundInvoiceReportSummaryRequest {
    employerId: number;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
    page?: number;
    size?: number;
}

export interface GetPrefundInvoiceReportSummaryCsvRequest {
    employerId: number;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
}

export interface GetReplenishmentInvoiceReportBreakdownRequest {
    employerId: number;
    searchValue?: string;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetReplenishmentInvoiceReportBreakdownCsvRequest {
    employerId: number;
    searchValue?: string;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
    showSsn?: boolean;
}

export interface GetReplenishmentInvoiceReportBriefRequest {
    observedOrganizationPath?: string;
}

export interface GetReplenishmentInvoiceReportSummaryRequest {
    employerId: number;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
    page?: number;
    size?: number;
}

export interface GetReplenishmentInvoiceReportSummaryCsvRequest {
    employerId: number;
    invoiceId?: number;
    invoiceCloseStartDate?: Date;
    invoiceCloseEndDate?: Date;
}

export interface GetReportMultiEmployersSummaryRequest {
    observedOrganizationPath?: string;
    employerIds?: Set<number>;
    page?: number;
    size?: number;
}

export interface GetReportResultPageRequest {
    searchValue?: string;
    startDateRange?: Date;
    endDateRange?: Date;
    types?: Set<GetReportResultPageTypesEnum>;
    groupTypes?: Set<GetReportResultPageGroupTypesEnum>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetReportSchedulerPageRequest {
    searchValue?: string;
    startDateRange?: Date;
    endDateRange?: Date;
    types?: Set<GetReportSchedulerPageTypesEnum>;
    groupTypes?: Set<GetReportSchedulerPageGroupTypesEnum>;
    statuses?: Set<GetReportSchedulerPageStatusesEnum>;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetTotalClaimSpendRequest {
    planYearId: number;
    observedOrganizationPath?: string;
}

export interface GetTotalMonthlyClaimSpendBreakdownRequest {
    planId: number;
    observedOrganizationPath?: string;
}

export interface GetUndeliverableAddressReportBreakdownRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    employmentStatuses?: Set<GetUndeliverableAddressReportBreakdownEmploymentStatusesEnum>;
    showSsn?: boolean;
    page?: number;
    size?: number;
}

export interface GetUndeliverableAddressReportBreakdownCsvRequest {
    observedOrganizationPath?: string;
    employerId?: number;
    employerIds?: Set<number>;
    searchValue?: string;
    employmentStatuses?: Set<GetUndeliverableAddressReportBreakdownCsvEmploymentStatusesEnum>;
    showSsn?: boolean;
}

export interface GetUndeliverableAddressReportBriefRequest {
    observedOrganizationPath?: string;
}

export interface GetUndeliverableMailMetricsRequest {
    observedOrganizationPath?: string;
}

export interface UpdateReportSchedulerRequest {
    id: number;
    iReportSchedulerUpdateDto: IReportSchedulerUpdateDto;
}

export interface UpsertReportPreferencesRequest {
    body: string;
}

/**
 * ReportServiceServiceApi - interface
 * 
 * @export
 * @interface ReportServiceServiceApiInterface
 */
export interface ReportServiceServiceApiInterface {
    /**
     * 
     * @summary Create Report Scheduler
     * @param {IReportSchedulerCreateDto} iReportSchedulerCreateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    createReportSchedulerRaw(requestParameters: CreateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSchedulerResponseDto>>;

    /**
     * Create Report Scheduler
     */
    createReportScheduler(requestParameters: CreateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSchedulerResponseDto>;

    /**
     * 
     * @summary Deactivate Report Scheduler
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    deactivateReportSchedulerRaw(requestParameters: DeactivateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSchedulerResponseDto>>;

    /**
     * Deactivate Report Scheduler
     */
    deactivateReportScheduler(requestParameters: DeactivateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSchedulerResponseDto>;

    /**
     * 
     * @summary Delete Report Result
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    deleteReportResultRaw(requestParameters: DeleteReportResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete Report Result
     */
    deleteReportResult(requestParameters: DeleteReportResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get plan years for Account Usage Total Spend section
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getAccountUsagePlanYearsRaw(requestParameters: GetAccountUsagePlanYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearResponseDto>>>;

    /**
     * Get plan years for Account Usage Total Spend section
     */
    getAccountUsagePlanYears(requestParameters: GetAccountUsagePlanYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearResponseDto>>;

    /**
     * 
     * @summary Get Card Status Multi-Employer Report Summary
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {'LAST_7_DAYS' | 'LAST_30_DAYS'} [cardStatusReportGroupType] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCardStatusMultiEmployerSummaryRaw(requestParameters: GetCardStatusMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto>>;

    /**
     * Get Card Status Multi-Employer Report Summary
     */
    getCardStatusMultiEmployerSummary(requestParameters: GetCardStatusMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto>;

    /**
     * 
     * @summary Generate Card Status Multi-Employer Report Summary CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {'LAST_7_DAYS' | 'LAST_30_DAYS'} [cardStatusReportGroupType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCardStatusMultiEmployerSummaryCsvRaw(requestParameters: GetCardStatusMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Card Status Multi-Employer Report Summary CSV
     */
    getCardStatusMultiEmployerSummaryCsv(requestParameters: GetCardStatusMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Card Status Report Breakdown
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {boolean} [isNotMailed] 
     * @param {Date} [mailedStartDate] 
     * @param {Date} [mailedEndDate] 
     * @param {Set<'ACTIVE' | 'CLOSED' | 'PENDING_CLOSED' | 'FROZEN' | 'LOST' | 'PENDING_OPEN' | 'PENDING_FROZEN' | 'PENDING_REPLACE' | 'STOLEN' | 'NOT_SENT' | 'PENDING_UNLOCK' | 'DAMAGED' | 'CLOSING' | 'DEMOGRAPHIC_CHANGE'>} [cardStatuses] 
     * @param {Set<'A' | 'T' | 'L' | 'R' | 'F' | 'C'>} [employmentStatuses] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCardStatusReportBreakdownRaw(requestParameters: GetCardStatusReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoCardStatusBreakdownRecordDto>>;

    /**
     * Get Card Status Report Breakdown
     */
    getCardStatusReportBreakdown(requestParameters: GetCardStatusReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoCardStatusBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Card Status Breakdown CSV Report
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {boolean} [isNotMailed] 
     * @param {Date} [mailedStartDate] 
     * @param {Date} [mailedEndDate] 
     * @param {Set<'ACTIVE' | 'CLOSED' | 'PENDING_CLOSED' | 'FROZEN' | 'LOST' | 'PENDING_OPEN' | 'PENDING_FROZEN' | 'PENDING_REPLACE' | 'STOLEN' | 'NOT_SENT' | 'PENDING_UNLOCK' | 'DAMAGED' | 'CLOSING' | 'DEMOGRAPHIC_CHANGE'>} [cardStatuses] 
     * @param {Set<'A' | 'T' | 'L' | 'R' | 'F' | 'C'>} [employmentStatuses] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCardStatusReportBreakdownCsvRaw(requestParameters: GetCardStatusReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Card Status Breakdown CSV Report
     */
    getCardStatusReportBreakdownCsv(requestParameters: GetCardStatusReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Card Status Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCardStatusReportBriefRaw(requestParameters: GetCardStatusReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardStatusBriefRecordDto>>;

    /**
     * Get Card Status Report Brief
     */
    getCardStatusReportBrief(requestParameters: GetCardStatusReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardStatusBriefRecordDto>;

    /**
     * 
     * @summary Get Card Status Report Summary
     * @param {number} employerId 
     * @param {'LAST_7_DAYS' | 'LAST_30_DAYS'} [cardStatusReportGroupType] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCardStatusReportSummaryRaw(requestParameters: GetCardStatusReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoCardStatusSummaryRecordDto>>;

    /**
     * Get Card Status Report Summary
     */
    getCardStatusReportSummary(requestParameters: GetCardStatusReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoCardStatusSummaryRecordDto>;

    /**
     * 
     * @summary Generate Card Status Report Summary CSV
     * @param {number} employerId 
     * @param {'LAST_7_DAYS' | 'LAST_30_DAYS'} [cardStatusReportGroupType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCardStatusReportSummaryCsvRaw(requestParameters: GetCardStatusReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Card Status Report Summary CSV
     */
    getCardStatusReportSummaryCsv(requestParameters: GetCardStatusReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get CIP config metrics for ER dashboard
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCipConfigMetricsRaw(requestParameters: GetCipConfigMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipConfigMetricsResponseDto>>;

    /**
     * Get CIP config metrics for ER dashboard
     */
    getCipConfigMetrics(requestParameters: GetCipConfigMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipConfigMetricsResponseDto>;

    /**
     * 
     * @summary Get CIP info metrics for ER dashboard
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCipInfoMetricsRaw(requestParameters: GetCipInfoMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipInfoMetricsResponseDto>>;

    /**
     * Get CIP info metrics for ER dashboard
     */
    getCipInfoMetrics(requestParameters: GetCipInfoMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipInfoMetricsResponseDto>;

    /**
     * 
     * @summary Get CIP status Report Breakdown
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {Date} [cipStatusStartDate] 
     * @param {Date} [cipStatusEndDate] 
     * @param {Set<'A' | 'T' | 'L' | 'R' | 'F' | 'C'>} [employmentStatuses] 
     * @param {Set<'OPEN' | 'CLOSED' | 'PENDING_CLOSED' | 'FROZEN' | 'PENDING'>} [accountStatuses] 
     * @param {Set<'ACTIVE' | 'CANCELED' | 'FUTURE' | 'EXPIRED'>} [enrollmentStatuses] 
     * @param {Set<'NONE' | 'PENDING' | 'PASS' | 'FAIL' | 'QUESTION' | 'RENEWED' | 'CIP_FAILED_ACCOUNT_CLOSE'>} [cipStatuses] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCipStatusReportBreakdownRaw(requestParameters: GetCipStatusReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoCipStatusBreakdownRecordDto>>;

    /**
     * Get CIP status Report Breakdown
     */
    getCipStatusReportBreakdown(requestParameters: GetCipStatusReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoCipStatusBreakdownRecordDto>;

    /**
     * 
     * @summary Generate CIP status Breakdown CSV Report
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {Date} [cipStatusStartDate] 
     * @param {Date} [cipStatusEndDate] 
     * @param {Set<'A' | 'T' | 'L' | 'R' | 'F' | 'C'>} [employmentStatuses] 
     * @param {Set<'OPEN' | 'CLOSED' | 'PENDING_CLOSED' | 'FROZEN' | 'PENDING'>} [accountStatuses] 
     * @param {Set<'ACTIVE' | 'CANCELED' | 'FUTURE' | 'EXPIRED'>} [enrollmentStatuses] 
     * @param {Set<'NONE' | 'PENDING' | 'PASS' | 'FAIL' | 'QUESTION' | 'RENEWED' | 'CIP_FAILED_ACCOUNT_CLOSE'>} [cipStatuses] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCipStatusReportBreakdownCsvRaw(requestParameters: GetCipStatusReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate CIP status Breakdown CSV Report
     */
    getCipStatusReportBreakdownCsv(requestParameters: GetCipStatusReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get CIP status Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCipStatusReportBriefRaw(requestParameters: GetCipStatusReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipStatusBriefDto>>;

    /**
     * Get CIP status Report Brief
     */
    getCipStatusReportBrief(requestParameters: GetCipStatusReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipStatusBriefDto>;

    /**
     * 
     * @summary Generate CIP status Report Multi-Employers Summary CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCipStatusReportMultiEmployersSummaryCsvRaw(requestParameters: GetCipStatusReportMultiEmployersSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate CIP status Report Multi-Employers Summary CSV
     */
    getCipStatusReportMultiEmployersSummaryCsv(requestParameters: GetCipStatusReportMultiEmployersSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get CIP status Report Summary
     * @param {number} employerId 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCipStatusReportSummaryRaw(requestParameters: GetCipStatusReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoCipStatusSummaryRecordDto>>;

    /**
     * Get CIP status Report Summary
     */
    getCipStatusReportSummary(requestParameters: GetCipStatusReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoCipStatusSummaryRecordDto>;

    /**
     * 
     * @summary Generate CIP status Report Summary CSV
     * @param {number} employerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getCipStatusReportSummaryCsvRaw(requestParameters: GetCipStatusReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate CIP status Report Summary CSV
     */
    getCipStatusReportSummaryCsv(requestParameters: GetCipStatusReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Claim Activity Multi-Employer Report Summary
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {Set<'PROCESSING' | 'NEEDS_HELP' | 'PAID' | 'PARTIALLY_PAID' | 'WAITING_FOR_FUNDS' | 'PENDING' | 'REPAID' | 'DENIED' | 'DECLINED' | 'REPROCESSING' | 'PARTIALLY_REPAID' | 'REPAYMENT_REQUIRED' | 'CANCELLED' | 'APPLIED_TO_DEDUCTIBLE' | 'OUT_OF_POCKET' | 'COMPLETE' | 'VOIDED' | 'PAID_INELIGIBLE_EXPENSE' | 'PENDING_ACCOUNT_VERIFICATION' | 'REPAYMENT_INITIATED'>} [claimStatuses] 
     * @param {Set<'REIMBURSEMENT' | 'BILL_PAY' | 'CARD_SWIPE'>} [claimTypes] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getClaimActivityMultiEmployerSummaryRaw(requestParameters: GetClaimActivityMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoClaimActivityMultiEmployersSummaryRecordDto>>;

    /**
     * Get Claim Activity Multi-Employer Report Summary
     */
    getClaimActivityMultiEmployerSummary(requestParameters: GetClaimActivityMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoClaimActivityMultiEmployersSummaryRecordDto>;

    /**
     * 
     * @summary Generate Claim Activity Multi-Employer Report Summary CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {Set<'PROCESSING' | 'NEEDS_HELP' | 'PAID' | 'PARTIALLY_PAID' | 'WAITING_FOR_FUNDS' | 'PENDING' | 'REPAID' | 'DENIED' | 'DECLINED' | 'REPROCESSING' | 'PARTIALLY_REPAID' | 'REPAYMENT_REQUIRED' | 'CANCELLED' | 'APPLIED_TO_DEDUCTIBLE' | 'OUT_OF_POCKET' | 'COMPLETE' | 'VOIDED' | 'PAID_INELIGIBLE_EXPENSE' | 'PENDING_ACCOUNT_VERIFICATION' | 'REPAYMENT_INITIATED'>} [claimStatuses] 
     * @param {Set<'REIMBURSEMENT' | 'BILL_PAY' | 'CARD_SWIPE'>} [claimTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getClaimActivityMultiEmployerSummaryCsvRaw(requestParameters: GetClaimActivityMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Claim Activity Multi-Employer Report Summary CSV
     */
    getClaimActivityMultiEmployerSummaryCsv(requestParameters: GetClaimActivityMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Claim Activity Report Breakdown
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {Date} [claimSubmitStartDate] 
     * @param {Date} [claimSubmitEndDate] 
     * @param {Date} [claimPaidStartDate] 
     * @param {Date} [claimPaidEndDate] 
     * @param {Set<'REIMBURSEMENT' | 'BILL_PAY' | 'CARD_SWIPE'>} [claimTypes] 
     * @param {Set<'PROCESSING' | 'NEEDS_HELP' | 'PAID' | 'PARTIALLY_PAID' | 'WAITING_FOR_FUNDS' | 'PENDING' | 'REPAID' | 'DENIED' | 'DECLINED' | 'REPROCESSING' | 'PARTIALLY_REPAID' | 'REPAYMENT_REQUIRED' | 'CANCELLED' | 'APPLIED_TO_DEDUCTIBLE' | 'OUT_OF_POCKET' | 'COMPLETE' | 'VOIDED' | 'PAID_INELIGIBLE_EXPENSE' | 'PENDING_ACCOUNT_VERIFICATION' | 'REPAYMENT_INITIATED'>} [claimStatuses] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getClaimActivityReportBreakdownRaw(requestParameters: GetClaimActivityReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoClaimActivityBreakdownRecordDto>>;

    /**
     * Get Claim Activity Report Breakdown
     */
    getClaimActivityReportBreakdown(requestParameters: GetClaimActivityReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoClaimActivityBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Claim Activity Breakdown CSV Report
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {Date} [claimSubmitStartDate] 
     * @param {Date} [claimSubmitEndDate] 
     * @param {Date} [claimPaidStartDate] 
     * @param {Date} [claimPaidEndDate] 
     * @param {Set<'REIMBURSEMENT' | 'BILL_PAY' | 'CARD_SWIPE'>} [claimTypes] 
     * @param {Set<'PROCESSING' | 'NEEDS_HELP' | 'PAID' | 'PARTIALLY_PAID' | 'WAITING_FOR_FUNDS' | 'PENDING' | 'REPAID' | 'DENIED' | 'DECLINED' | 'REPROCESSING' | 'PARTIALLY_REPAID' | 'REPAYMENT_REQUIRED' | 'CANCELLED' | 'APPLIED_TO_DEDUCTIBLE' | 'OUT_OF_POCKET' | 'COMPLETE' | 'VOIDED' | 'PAID_INELIGIBLE_EXPENSE' | 'PENDING_ACCOUNT_VERIFICATION' | 'REPAYMENT_INITIATED'>} [claimStatuses] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getClaimActivityReportBreakdownCsvRaw(requestParameters: GetClaimActivityReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Claim Activity Breakdown CSV Report
     */
    getClaimActivityReportBreakdownCsv(requestParameters: GetClaimActivityReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Claim Activity Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getClaimActivityReportBriefRaw(requestParameters: GetClaimActivityReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimActivityBriefDto>>;

    /**
     * Get Claim Activity Report Brief
     */
    getClaimActivityReportBrief(requestParameters: GetClaimActivityReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimActivityBriefDto>;

    /**
     * 
     * @summary Get Claim Activity Report Summary
     * @param {number} employerId 
     * @param {Set<'PROCESSING' | 'NEEDS_HELP' | 'PAID' | 'PARTIALLY_PAID' | 'WAITING_FOR_FUNDS' | 'PENDING' | 'REPAID' | 'DENIED' | 'DECLINED' | 'REPROCESSING' | 'PARTIALLY_REPAID' | 'REPAYMENT_REQUIRED' | 'CANCELLED' | 'APPLIED_TO_DEDUCTIBLE' | 'OUT_OF_POCKET' | 'COMPLETE' | 'VOIDED' | 'PAID_INELIGIBLE_EXPENSE' | 'PENDING_ACCOUNT_VERIFICATION' | 'REPAYMENT_INITIATED'>} [claimStatuses] 
     * @param {Set<'REIMBURSEMENT' | 'BILL_PAY' | 'CARD_SWIPE'>} [claimTypes] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getClaimActivityReportSummaryRaw(requestParameters: GetClaimActivityReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoClaimActivitySummaryRecordDto>>;

    /**
     * Get Claim Activity Report Summary
     */
    getClaimActivityReportSummary(requestParameters: GetClaimActivityReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoClaimActivitySummaryRecordDto>;

    /**
     * 
     * @summary Generate Claim Activity Report Summary CSV
     * @param {number} employerId 
     * @param {Set<'PROCESSING' | 'NEEDS_HELP' | 'PAID' | 'PARTIALLY_PAID' | 'WAITING_FOR_FUNDS' | 'PENDING' | 'REPAID' | 'DENIED' | 'DECLINED' | 'REPROCESSING' | 'PARTIALLY_REPAID' | 'REPAYMENT_REQUIRED' | 'CANCELLED' | 'APPLIED_TO_DEDUCTIBLE' | 'OUT_OF_POCKET' | 'COMPLETE' | 'VOIDED' | 'PAID_INELIGIBLE_EXPENSE' | 'PENDING_ACCOUNT_VERIFICATION' | 'REPAYMENT_INITIATED'>} [claimStatuses] 
     * @param {Set<'REIMBURSEMENT' | 'BILL_PAY' | 'CARD_SWIPE'>} [claimTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getClaimActivityReportSummaryCsvRaw(requestParameters: GetClaimActivityReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Claim Activity Report Summary CSV
     */
    getClaimActivityReportSummaryCsv(requestParameters: GetClaimActivityReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get claim spend breakdown for Account Usage Details page
     * @param {number} planId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getClaimDetailsRaw(requestParameters: GetClaimDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimDetailsResponseDto>>;

    /**
     * Get claim spend breakdown for Account Usage Details page
     */
    getClaimDetails(requestParameters: GetClaimDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimDetailsResponseDto>;

    /**
     * 
     * @summary Get claims substantiation rate metrics for ER dashboard
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getClaimsSubstantiationRateMetricsRaw(requestParameters: GetClaimsSubstantiationRateMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsSubstantiationRateMetricsResponseDto>>;

    /**
     * Get claims substantiation rate metrics for ER dashboard
     */
    getClaimsSubstantiationRateMetrics(requestParameters: GetClaimsSubstantiationRateMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsSubstantiationRateMetricsResponseDto>;

    /**
     * 
     * @summary Get Contribution Invoice Report Breakdown
     * @param {number} employerId 
     * @param {string} [searchValue] 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getContributionInvoiceReportBreakdownRaw(requestParameters: GetContributionInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoContributionInvoiceBreakdownRecordDto>>;

    /**
     * Get Contribution Invoice Report Breakdown
     */
    getContributionInvoiceReportBreakdown(requestParameters: GetContributionInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoContributionInvoiceBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Contribution Invoice Breakdown CSV Report
     * @param {number} employerId 
     * @param {string} [searchValue] 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getContributionInvoiceReportBreakdownCsvRaw(requestParameters: GetContributionInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Contribution Invoice Breakdown CSV Report
     */
    getContributionInvoiceReportBreakdownCsv(requestParameters: GetContributionInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Contribution Invoice Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getContributionInvoiceReportBriefRaw(requestParameters: GetContributionInvoiceReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceBriefRecordDto>>;

    /**
     * Get Contribution Invoice Report Brief
     */
    getContributionInvoiceReportBrief(requestParameters: GetContributionInvoiceReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceBriefRecordDto>;

    /**
     * 
     * @summary Get Contribution Invoice Report Summary
     * @param {number} employerId 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getContributionInvoiceReportSummaryRaw(requestParameters: GetContributionInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoInvoiceSummaryRecordDto>>;

    /**
     * Get Contribution Invoice Report Summary
     */
    getContributionInvoiceReportSummary(requestParameters: GetContributionInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoInvoiceSummaryRecordDto>;

    /**
     * 
     * @summary Generate Contribution Invoice Report Summary CSV
     * @param {number} employerId 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getContributionInvoiceReportSummaryCsvRaw(requestParameters: GetContributionInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Contribution Invoice Report Summary CSV
     */
    getContributionInvoiceReportSummaryCsv(requestParameters: GetContributionInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get delinquent claims metrics for ER dashboard
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getDelinquentClaimsMetricsRaw(requestParameters: GetDelinquentClaimsMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDelinquentClaimsMetricsResponseDto>>;

    /**
     * Get delinquent claims metrics for ER dashboard
     */
    getDelinquentClaimsMetrics(requestParameters: GetDelinquentClaimsMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDelinquentClaimsMetricsResponseDto>;

    /**
     * 
     * @summary Get Delinquent Claims Multi-Employer Report Summary
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {Set<'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'>} [accountTypes] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getDelinquentClaimsMultiEmployerSummaryRaw(requestParameters: GetDelinquentClaimsMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoDelinquentClaimsMultiEmployersSummaryRecordDto>>;

    /**
     * Get Delinquent Claims Multi-Employer Report Summary
     */
    getDelinquentClaimsMultiEmployerSummary(requestParameters: GetDelinquentClaimsMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoDelinquentClaimsMultiEmployersSummaryRecordDto>;

    /**
     * 
     * @summary Generate Delinquent Claims Multi-Employer Report Summary CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {Set<'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'>} [accountTypes] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getDelinquentClaimsMultiEmployerSummaryCsvRaw(requestParameters: GetDelinquentClaimsMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Delinquent Claims Multi-Employer Report Summary CSV
     */
    getDelinquentClaimsMultiEmployerSummaryCsv(requestParameters: GetDelinquentClaimsMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Delinquent Claims Report Breakdown
     * @param {'BY_EMPLOYEE' | 'BY_CLAIM'} delinquentClaimsViewType 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriods] 
     * @param {Set<'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'>} [accountTypes] 
     * @param {Set<'PROCESSING' | 'NEEDS_HELP' | 'PAID' | 'PARTIALLY_PAID' | 'WAITING_FOR_FUNDS' | 'PENDING' | 'REPAID' | 'DENIED' | 'DECLINED' | 'REPROCESSING' | 'PARTIALLY_REPAID' | 'REPAYMENT_REQUIRED' | 'CANCELLED' | 'APPLIED_TO_DEDUCTIBLE' | 'OUT_OF_POCKET' | 'COMPLETE' | 'VOIDED' | 'PAID_INELIGIBLE_EXPENSE' | 'PENDING_ACCOUNT_VERIFICATION' | 'REPAYMENT_INITIATED'>} [claimStatuses] 
     * @param {string} [searchValue] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getDelinquentClaimsReportBreakdownRaw(requestParameters: GetDelinquentClaimsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoBaseBreakdownRecordDto>>;

    /**
     * Get Delinquent Claims Report Breakdown
     */
    getDelinquentClaimsReportBreakdown(requestParameters: GetDelinquentClaimsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoBaseBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Delinquent Claims Report Breakdown CSV
     * @param {'BY_EMPLOYEE' | 'BY_CLAIM'} delinquentClaimsViewType 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriods] 
     * @param {Set<'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'>} [accountTypes] 
     * @param {Set<'PROCESSING' | 'NEEDS_HELP' | 'PAID' | 'PARTIALLY_PAID' | 'WAITING_FOR_FUNDS' | 'PENDING' | 'REPAID' | 'DENIED' | 'DECLINED' | 'REPROCESSING' | 'PARTIALLY_REPAID' | 'REPAYMENT_REQUIRED' | 'CANCELLED' | 'APPLIED_TO_DEDUCTIBLE' | 'OUT_OF_POCKET' | 'COMPLETE' | 'VOIDED' | 'PAID_INELIGIBLE_EXPENSE' | 'PENDING_ACCOUNT_VERIFICATION' | 'REPAYMENT_INITIATED'>} [claimStatuses] 
     * @param {string} [searchValue] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getDelinquentClaimsReportBreakdownCsvRaw(requestParameters: GetDelinquentClaimsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Delinquent Claims Report Breakdown CSV
     */
    getDelinquentClaimsReportBreakdownCsv(requestParameters: GetDelinquentClaimsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Delinquent Claims Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getDelinquentClaimsReportBriefRaw(requestParameters: GetDelinquentClaimsReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDelinquentClaimsBriefDto>>;

    /**
     * Get Delinquent Claims Report Brief
     */
    getDelinquentClaimsReportBrief(requestParameters: GetDelinquentClaimsReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDelinquentClaimsBriefDto>;

    /**
     * 
     * @summary Get Delinquent Claims Report Single Employer Summary
     * @param {number} employerId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {Set<'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'>} [accountTypes] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getDelinquentClaimsReportSummaryRaw(requestParameters: GetDelinquentClaimsReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoDelinquentClaimsSummaryRecordDto>>;

    /**
     * Get Delinquent Claims Report Single Employer Summary
     */
    getDelinquentClaimsReportSummary(requestParameters: GetDelinquentClaimsReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoDelinquentClaimsSummaryRecordDto>;

    /**
     * 
     * @summary Generate Delinquent Claims Report Single Employer Summary CSV
     * @param {number} employerId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {Set<'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'>} [accountTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getDelinquentClaimsReportSummaryCsvRaw(requestParameters: GetDelinquentClaimsReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Delinquent Claims Report Single Employer Summary CSV
     */
    getDelinquentClaimsReportSummaryCsv(requestParameters: GetDelinquentClaimsReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Employee Demographics Report Breakdown
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {Set<'A' | 'T' | 'L' | 'R' | 'F' | 'C'>} [employmentStatuses] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getEmployeeDemographicsReportBreakdownRaw(requestParameters: GetEmployeeDemographicsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoEmployeeDemographicsBreakdownRecordDto>>;

    /**
     * Get Employee Demographics Report Breakdown
     */
    getEmployeeDemographicsReportBreakdown(requestParameters: GetEmployeeDemographicsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoEmployeeDemographicsBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Employee Demographics Report Breakdown CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {Set<'A' | 'T' | 'L' | 'R' | 'F' | 'C'>} [employmentStatuses] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getEmployeeDemographicsReportBreakdownCsvRaw(requestParameters: GetEmployeeDemographicsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Employee Demographics Report Breakdown CSV
     */
    getEmployeeDemographicsReportBreakdownCsv(requestParameters: GetEmployeeDemographicsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get total employee metrics for ER dashboard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getEmployeeMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeMetricsResponseDto>>;

    /**
     * Get total employee metrics for ER dashboard
     */
    getEmployeeMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeMetricsResponseDto>;

    /**
     * 
     * @summary Get employer calendar events
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Date} [fromDate] 
     * @param {Date} [toDate] 
     * @param {Array<'PLAN_DATES' | 'FUNDING'>} [categories] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getEmployerCalendarEventsRaw(requestParameters: GetEmployerCalendarEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerCalendarEventsResponseDto>>;

    /**
     * Get employer calendar events
     */
    getEmployerCalendarEvents(requestParameters: GetEmployerCalendarEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerCalendarEventsResponseDto>;

    /**
     * 
     * @summary Get Forfeiture Report Breakdown
     * @param {number} employerId 
     * @param {'EMPLOYEE' | 'TRANSACTION'} forfeitureReportGroup 
     * @param {string} [searchValue] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getForfeitureReportBreakdownRaw(requestParameters: GetForfeitureReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoBaseBreakdownRecordDto>>;

    /**
     * Get Forfeiture Report Breakdown
     */
    getForfeitureReportBreakdown(requestParameters: GetForfeitureReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoBaseBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Forfeiture Report Breakdown CSV
     * @param {number} employerId 
     * @param {'EMPLOYEE' | 'TRANSACTION'} forfeitureReportGroup 
     * @param {string} [searchValue] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getForfeitureReportBreakdownCsvRaw(requestParameters: GetForfeitureReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Forfeiture Report Breakdown CSV
     */
    getForfeitureReportBreakdownCsv(requestParameters: GetForfeitureReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Forfeiture Report Summary
     * @param {number} employerId 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getForfeitureReportSummaryRaw(requestParameters: GetForfeitureReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoForfeitureSummaryRecordDto>>;

    /**
     * Get Forfeiture Report Summary
     */
    getForfeitureReportSummary(requestParameters: GetForfeitureReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoForfeitureSummaryRecordDto>;

    /**
     * 
     * @summary Generate Forfeiture Report Summary CSV
     * @param {number} employerId 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getForfeitureReportSummaryCsvRaw(requestParameters: GetForfeitureReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Forfeiture Report Summary CSV
     */
    getForfeitureReportSummaryCsv(requestParameters: GetForfeitureReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get fraud review required metrics for ER dashboard
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getFraudReviewRequiredMetricsRaw(requestParameters: GetFraudReviewRequiredMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFraudReviewRequiredMetricsResponseDto>>;

    /**
     * Get fraud review required metrics for ER dashboard
     */
    getFraudReviewRequiredMetrics(requestParameters: GetFraudReviewRequiredMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFraudReviewRequiredMetricsResponseDto>;

    /**
     * 
     * @summary Get Health Plan Enrollment Report Breakdown
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {Set<number>} [planIds] 
     * @param {string} [searchValue] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getHealthPlanEnrollmentReportBreakdownRaw(requestParameters: GetHealthPlanEnrollmentReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoHealthPlanEnrollmentBreakdownRecordDto>>;

    /**
     * Get Health Plan Enrollment Report Breakdown
     */
    getHealthPlanEnrollmentReportBreakdown(requestParameters: GetHealthPlanEnrollmentReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoHealthPlanEnrollmentBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Health Plan Enrollment Report Breakdown CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {Set<number>} [planIds] 
     * @param {string} [searchValue] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getHealthPlanEnrollmentReportBreakdownCsvRaw(requestParameters: GetHealthPlanEnrollmentReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Health Plan Enrollment Report Breakdown CSV
     */
    getHealthPlanEnrollmentReportBreakdownCsv(requestParameters: GetHealthPlanEnrollmentReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Health Plan Enrollment Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getHealthPlanEnrollmentReportBriefRaw(requestParameters: GetHealthPlanEnrollmentReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHealthPlanEnrollmentBriefDto>>;

    /**
     * Get Health Plan Enrollment Report Brief
     */
    getHealthPlanEnrollmentReportBrief(requestParameters: GetHealthPlanEnrollmentReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHealthPlanEnrollmentBriefDto>;

    /**
     * 
     * @summary Get Health Plan Enrollment Report Summary
     * @param {number} employerId 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getHealthPlanEnrollmentReportSummaryRaw(requestParameters: GetHealthPlanEnrollmentReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto>>;

    /**
     * Get Health Plan Enrollment Report Summary
     */
    getHealthPlanEnrollmentReportSummary(requestParameters: GetHealthPlanEnrollmentReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto>;

    /**
     * 
     * @summary Generate Health Plan Enrollment Report Summary CSV
     * @param {number} employerId 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getHealthPlanEnrollmentReportSummaryCsvRaw(requestParameters: GetHealthPlanEnrollmentReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Health Plan Enrollment Report Summary CSV
     */
    getHealthPlanEnrollmentReportSummaryCsv(requestParameters: GetHealthPlanEnrollmentReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get HSA cash and investment balance breakdown for Account Usage Details page
     * @param {number} planId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getHsaBalancesRaw(requestParameters: GetHsaBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHsaPlanBalanceMonthlyBreakdownResponseDto>>;

    /**
     * Get HSA cash and investment balance breakdown for Account Usage Details page
     */
    getHsaBalances(requestParameters: GetHsaBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHsaPlanBalanceMonthlyBreakdownResponseDto>;

    /**
     * 
     * @summary Get HSA plan overview metrics
     * @param {number} planId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getHsaOverviewRaw(requestParameters: GetHsaOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHsaOverviewResponseDto>>;

    /**
     * Get HSA plan overview metrics
     */
    getHsaOverview(requestParameters: GetHsaOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHsaOverviewResponseDto>;

    /**
     * 
     * @summary Get HSA plan details and deadlines
     * @param {number} planId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getHsaPlanDetailsRaw(requestParameters: GetHsaPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHsaDetailsResponseDto>>;

    /**
     * Get HSA plan details and deadlines
     */
    getHsaPlanDetails(requestParameters: GetHsaPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHsaDetailsResponseDto>;

    /**
     * 
     * @summary Get invoice plan level replenishment metrics for ER dashboard
     * @param {Date} startDate 
     * @param {Date} endDate 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getInvoicePlanLevelReplenishmentMetricsRaw(requestParameters: GetInvoicePlanLevelReplenishmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IInvoicePlanLevelReplenishmentMetricsResponseDto>>>;

    /**
     * Get invoice plan level replenishment metrics for ER dashboard
     */
    getInvoicePlanLevelReplenishmentMetrics(requestParameters: GetInvoicePlanLevelReplenishmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IInvoicePlanLevelReplenishmentMetricsResponseDto>>;

    /**
     * 
     * @summary Get invoice replenishment metrics for ER dashboard
     * @param {Date} startDate 
     * @param {Date} endDate 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getInvoiceReplenishmentMetricsRaw(requestParameters: GetInvoiceReplenishmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceReplenishmentMetricsResponseDto>>;

    /**
     * Get invoice replenishment metrics for ER dashboard
     */
    getInvoiceReplenishmentMetrics(requestParameters: GetInvoiceReplenishmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceReplenishmentMetricsResponseDto>;

    /**
     * 
     * @summary Get notional plan overview metrics
     * @param {number} planId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getNotionalOverviewRaw(requestParameters: GetNotionalOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<INotionalOverviewResponseDto>>;

    /**
     * Get notional plan overview metrics
     */
    getNotionalOverview(requestParameters: GetNotionalOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<INotionalOverviewResponseDto>;

    /**
     * 
     * @summary Get notional plan details and deadlines
     * @param {number} planId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getNotionalPlanDetailsRaw(requestParameters: GetNotionalPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<INotionalDetailsResponseDto>>;

    /**
     * Get notional plan details and deadlines
     */
    getNotionalPlanDetails(requestParameters: GetNotionalPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<INotionalDetailsResponseDto>;

    /**
     * 
     * @summary Get PAA Multi-Employer Report Summary
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPaaMultiEmployerSummaryRaw(requestParameters: GetPaaMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoParticipantAccountActivityMultiEmployersSummaryRecordDto>>;

    /**
     * Get PAA Multi-Employer Report Summary
     */
    getPaaMultiEmployerSummary(requestParameters: GetPaaMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoParticipantAccountActivityMultiEmployersSummaryRecordDto>;

    /**
     * 
     * @summary Generate PAA Multi-Employer Report Summary CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPaaMultiEmployerSummaryCsvRaw(requestParameters: GetPaaMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate PAA Multi-Employer Report Summary CSV
     */
    getPaaMultiEmployerSummaryCsv(requestParameters: GetPaaMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Participant Account Activity Report Breakdown
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {Set<number>} [planIds] 
     * @param {Date} [asOfDate] 
     * @param {string} [searchValue] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {Set<'ACTIVE' | 'CANCELED' | 'FUTURE' | 'EXPIRED'>} [enrollmentStatuses] 
     * @param {boolean} [showSsn] 
     * @param {Set<'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'>} [accountTypes] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getParticipantAccountActivityReportBreakdownRaw(requestParameters: GetParticipantAccountActivityReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoParticipantAccountActivityBreakdownRecordDto>>;

    /**
     * Get Participant Account Activity Report Breakdown
     */
    getParticipantAccountActivityReportBreakdown(requestParameters: GetParticipantAccountActivityReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoParticipantAccountActivityBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Participant Account Activity Report Breakdown CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {Set<number>} [planIds] 
     * @param {Date} [asOfDate] 
     * @param {string} [searchValue] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {Set<'ACTIVE' | 'CANCELED' | 'FUTURE' | 'EXPIRED'>} [enrollmentStatuses] 
     * @param {boolean} [showSsn] 
     * @param {Set<'HSA' | 'HCFSA' | 'HRA' | 'DCAP' | 'EXTERNAL' | 'CLEARING' | 'SUB_ACCOUNT' | 'OMNIBUS' | 'PARKING' | 'TRANSIT' | 'ADOPTION' | 'SPECIALTY' | 'LIFESTYLE' | 'WAGEPARITY' | 'PLAN_OMNIBUS' | 'NOTIONAL_PAYROLL' | 'NOTIONAL_FUNDING' | 'TRAVEL'>} [accountTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getParticipantAccountActivityReportBreakdownCsvRaw(requestParameters: GetParticipantAccountActivityReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Participant Account Activity Report Breakdown CSV
     */
    getParticipantAccountActivityReportBreakdownCsv(requestParameters: GetParticipantAccountActivityReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Participant Account Activity Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getParticipantAccountActivityReportBriefRaw(requestParameters: GetParticipantAccountActivityReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IParticipantAccountActivityBriefDto>>;

    /**
     * Get Participant Account Activity Report Brief
     */
    getParticipantAccountActivityReportBrief(requestParameters: GetParticipantAccountActivityReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IParticipantAccountActivityBriefDto>;

    /**
     * 
     * @summary Get Participant Account Activity Report Summary
     * @param {number} employerId 
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getParticipantAccountActivityReportSummaryRaw(requestParameters: GetParticipantAccountActivityReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto>>;

    /**
     * Get Participant Account Activity Report Summary
     */
    getParticipantAccountActivityReportSummary(requestParameters: GetParticipantAccountActivityReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto>;

    /**
     * 
     * @summary Generate Participant Account Activity Report Summary CSV
     * @param {number} employerId 
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getParticipantAccountActivityReportSummaryCsvRaw(requestParameters: GetParticipantAccountActivityReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Participant Account Activity Report Summary CSV
     */
    getParticipantAccountActivityReportSummaryCsv(requestParameters: GetParticipantAccountActivityReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Payroll Contributions Multi-Employer Report Summary
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPayrollContributionsMultiEmployerSummaryRaw(requestParameters: GetPayrollContributionsMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoPayrollContributionsMultiEmployersSummaryRecordDto>>;

    /**
     * Get Payroll Contributions Multi-Employer Report Summary
     */
    getPayrollContributionsMultiEmployerSummary(requestParameters: GetPayrollContributionsMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoPayrollContributionsMultiEmployersSummaryRecordDto>;

    /**
     * 
     * @summary Generate Payroll Contributions Multi-Employer Report Summary CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPayrollContributionsMultiEmployerSummaryCsvRaw(requestParameters: GetPayrollContributionsMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Payroll Contributions Multi-Employer Report Summary CSV
     */
    getPayrollContributionsMultiEmployerSummaryCsv(requestParameters: GetPayrollContributionsMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Payroll Contributions Report Breakdown
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {Set<number>} [planIds] 
     * @param {Date} [contributionStartDate] 
     * @param {Date} [contributionEndDate] 
     * @param {Date} [transactionStartDate] 
     * @param {Date} [transactionEndDate] 
     * @param {string} [searchValue] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPayrollContributionsReportBreakdownRaw(requestParameters: GetPayrollContributionsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoPayrollContributionsBreakdownRecordDto>>;

    /**
     * Get Payroll Contributions Report Breakdown
     */
    getPayrollContributionsReportBreakdown(requestParameters: GetPayrollContributionsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoPayrollContributionsBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Payroll Contributions Report Breakdown CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {Set<number>} [planIds] 
     * @param {Date} [contributionStartDate] 
     * @param {Date} [contributionEndDate] 
     * @param {Date} [transactionStartDate] 
     * @param {Date} [transactionEndDate] 
     * @param {string} [searchValue] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPayrollContributionsReportBreakdownCsvRaw(requestParameters: GetPayrollContributionsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Payroll Contributions Report Breakdown CSV
     */
    getPayrollContributionsReportBreakdownCsv(requestParameters: GetPayrollContributionsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Payroll Contributions Report Summary
     * @param {number} employerId 
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPayrollContributionsReportSummaryRaw(requestParameters: GetPayrollContributionsReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoPayrollContributionsSummaryRecordDto>>;

    /**
     * Get Payroll Contributions Report Summary
     */
    getPayrollContributionsReportSummary(requestParameters: GetPayrollContributionsReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoPayrollContributionsSummaryRecordDto>;

    /**
     * 
     * @summary Generate Payroll Contributions Report Summary CSV
     * @param {number} employerId 
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPayrollContributionsReportSummaryCsvRaw(requestParameters: GetPayrollContributionsReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Payroll Contributions Report Summary CSV
     */
    getPayrollContributionsReportSummaryCsv(requestParameters: GetPayrollContributionsReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get plan enrollment metrics for ER dashboard
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPlanEnrollmentMetricsRaw(requestParameters: GetPlanEnrollmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanEnrollmentMetricsResponseDto>>;

    /**
     * Get plan enrollment metrics for ER dashboard
     */
    getPlanEnrollmentMetrics(requestParameters: GetPlanEnrollmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanEnrollmentMetricsResponseDto>;

    /**
     * 
     * @summary Get Plan Omnibus Balance Report Breakdown
     * @param {number} employerId 
     * @param {Set<number>} planIds 
     * @param {string} [searchValue] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPlanOmnibusBalanceReportBreakdownRaw(requestParameters: GetPlanOmnibusBalanceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoPlanOmnibusBalanceBreakdownRecordDto>>;

    /**
     * Get Plan Omnibus Balance Report Breakdown
     */
    getPlanOmnibusBalanceReportBreakdown(requestParameters: GetPlanOmnibusBalanceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoPlanOmnibusBalanceBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Plan Omnibus Balance Report Breakdown CSV
     * @param {number} employerId 
     * @param {Set<number>} planIds 
     * @param {string} [searchValue] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPlanOmnibusBalanceReportBreakdownCsvRaw(requestParameters: GetPlanOmnibusBalanceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Plan Omnibus Balance Report Breakdown CSV
     */
    getPlanOmnibusBalanceReportBreakdownCsv(requestParameters: GetPlanOmnibusBalanceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Plan Omnibus Balance Report Breakdown plans
     * @param {number} employerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPlanOmnibusBalanceReportBreakdownPlansRaw(requestParameters: GetPlanOmnibusBalanceReportBreakdownPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanDto>>>;

    /**
     * Get Plan Omnibus Balance Report Breakdown plans
     */
    getPlanOmnibusBalanceReportBreakdownPlans(requestParameters: GetPlanOmnibusBalanceReportBreakdownPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanDto>>;

    /**
     * 
     * @summary Get Plan Omnibus Balance Report Summary
     * @param {number} employerId 
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPlanOmnibusBalanceReportSummaryRaw(requestParameters: GetPlanOmnibusBalanceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoPlanOmnibusBalanceSummaryRecordDto>>;

    /**
     * Get Plan Omnibus Balance Report Summary
     */
    getPlanOmnibusBalanceReportSummary(requestParameters: GetPlanOmnibusBalanceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoPlanOmnibusBalanceSummaryRecordDto>;

    /**
     * 
     * @summary Generate Plan Omnibus Balance Report Summary CSV
     * @param {number} employerId 
     * @param {Set<number>} [planIds] 
     * @param {Set<'CURRENT' | 'PRIOR' | 'FUTURE' | 'OLDER'>} [planYearPeriod] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPlanOmnibusBalanceReportSummaryCsvRaw(requestParameters: GetPlanOmnibusBalanceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Plan Omnibus Balance Report Summary CSV
     */
    getPlanOmnibusBalanceReportSummaryCsv(requestParameters: GetPlanOmnibusBalanceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get plans for Account Usage account selector
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {string} [searchValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPlansRaw(requestParameters: GetPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanResponseDto>>>;

    /**
     * Get plans for Account Usage account selector
     */
    getPlans(requestParameters: GetPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanResponseDto>>;

    /**
     * 
     * @summary Get Prefund Invoice Report Breakdown
     * @param {number} employerId 
     * @param {string} [searchValue] 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPrefundInvoiceReportBreakdownRaw(requestParameters: GetPrefundInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoPrefundInvoiceBreakdownRecordDto>>;

    /**
     * Get Prefund Invoice Report Breakdown
     */
    getPrefundInvoiceReportBreakdown(requestParameters: GetPrefundInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoPrefundInvoiceBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Prefund Invoice Breakdown CSV Report
     * @param {number} employerId 
     * @param {string} [searchValue] 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPrefundInvoiceReportBreakdownCsvRaw(requestParameters: GetPrefundInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Prefund Invoice Breakdown CSV Report
     */
    getPrefundInvoiceReportBreakdownCsv(requestParameters: GetPrefundInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Prefund Invoice Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPrefundInvoiceReportBriefRaw(requestParameters: GetPrefundInvoiceReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceBriefRecordDto>>;

    /**
     * Get Prefund Invoice Report Brief
     */
    getPrefundInvoiceReportBrief(requestParameters: GetPrefundInvoiceReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceBriefRecordDto>;

    /**
     * 
     * @summary Get Prefund Invoice Report Summary
     * @param {number} employerId 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPrefundInvoiceReportSummaryRaw(requestParameters: GetPrefundInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoInvoiceSummaryRecordDto>>;

    /**
     * Get Prefund Invoice Report Summary
     */
    getPrefundInvoiceReportSummary(requestParameters: GetPrefundInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoInvoiceSummaryRecordDto>;

    /**
     * 
     * @summary Generate Prefund Invoice Report Summary CSV
     * @param {number} employerId 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getPrefundInvoiceReportSummaryCsvRaw(requestParameters: GetPrefundInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Prefund Invoice Report Summary CSV
     */
    getPrefundInvoiceReportSummaryCsv(requestParameters: GetPrefundInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Replenishment Invoice Report Breakdown
     * @param {number} employerId 
     * @param {string} [searchValue] 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getReplenishmentInvoiceReportBreakdownRaw(requestParameters: GetReplenishmentInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoReplenishmentInvoiceBreakdownRecordDto>>;

    /**
     * Get Replenishment Invoice Report Breakdown
     */
    getReplenishmentInvoiceReportBreakdown(requestParameters: GetReplenishmentInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoReplenishmentInvoiceBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Replenishment Invoice Breakdown CSV Report
     * @param {number} employerId 
     * @param {string} [searchValue] 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getReplenishmentInvoiceReportBreakdownCsvRaw(requestParameters: GetReplenishmentInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Replenishment Invoice Breakdown CSV Report
     */
    getReplenishmentInvoiceReportBreakdownCsv(requestParameters: GetReplenishmentInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Replenishment Invoice Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getReplenishmentInvoiceReportBriefRaw(requestParameters: GetReplenishmentInvoiceReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceBriefRecordDto>>;

    /**
     * Get Replenishment Invoice Report Brief
     */
    getReplenishmentInvoiceReportBrief(requestParameters: GetReplenishmentInvoiceReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceBriefRecordDto>;

    /**
     * 
     * @summary Get Replenishment Invoice Report Summary
     * @param {number} employerId 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getReplenishmentInvoiceReportSummaryRaw(requestParameters: GetReplenishmentInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoInvoiceSummaryRecordDto>>;

    /**
     * Get Replenishment Invoice Report Summary
     */
    getReplenishmentInvoiceReportSummary(requestParameters: GetReplenishmentInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoInvoiceSummaryRecordDto>;

    /**
     * 
     * @summary Generate Replenishment Invoice Report Summary CSV
     * @param {number} employerId 
     * @param {number} [invoiceId] 
     * @param {Date} [invoiceCloseStartDate] 
     * @param {Date} [invoiceCloseEndDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getReplenishmentInvoiceReportSummaryCsvRaw(requestParameters: GetReplenishmentInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Replenishment Invoice Report Summary CSV
     */
    getReplenishmentInvoiceReportSummaryCsv(requestParameters: GetReplenishmentInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get CIP status Report Multi-Employers Summary
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {Set<number>} [employerIds] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getReportMultiEmployersSummaryRaw(requestParameters: GetReportMultiEmployersSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoCipStatusMultiEmployersSummaryRecordDto>>;

    /**
     * Get CIP status Report Multi-Employers Summary
     */
    getReportMultiEmployersSummary(requestParameters: GetReportMultiEmployersSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoCipStatusMultiEmployersSummaryRecordDto>;

    /**
     * 
     * @summary Get Report Preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getReportPreferencesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Get Report Preferences
     */
    getReportPreferences(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get Report Result page
     * @param {string} [searchValue] 
     * @param {Date} [startDateRange] 
     * @param {Date} [endDateRange] 
     * @param {Set<'PARTICIPANT_ACCOUNT_ACTIVITY' | 'PAYROLL_CONTRIBUTIONS' | 'EMPLOYEE_DEMOGRAPHICS' | 'CLAIM_ACTIVITY' | 'FORFEITURE' | 'HEALTH_PLAN_ENROLLMENT' | 'CARD_STATUS' | 'CIP_STATUS' | 'REPLENISHMENT_INVOICE' | 'CONTRIBUTION_INVOICE' | 'PREFUND_INVOICE' | 'PLAN_OMNIBUS_BALANCE' | 'UNDELIVERABLE_ADDRESS' | 'DELINQUENT_CLAIMS'>} [types] 
     * @param {Set<'SUMMARY' | 'BREAKDOWN'>} [groupTypes] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getReportResultPageRaw(requestParameters: GetReportResultPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageReportResultResponseDto>>;

    /**
     * Get Report Result page
     */
    getReportResultPage(requestParameters: GetReportResultPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageReportResultResponseDto>;

    /**
     * 
     * @summary Get Report Scheduler page
     * @param {string} [searchValue] 
     * @param {Date} [startDateRange] 
     * @param {Date} [endDateRange] 
     * @param {Set<'PARTICIPANT_ACCOUNT_ACTIVITY' | 'PAYROLL_CONTRIBUTIONS' | 'EMPLOYEE_DEMOGRAPHICS' | 'CLAIM_ACTIVITY' | 'FORFEITURE' | 'HEALTH_PLAN_ENROLLMENT' | 'CARD_STATUS' | 'CIP_STATUS' | 'REPLENISHMENT_INVOICE' | 'CONTRIBUTION_INVOICE' | 'PREFUND_INVOICE' | 'PLAN_OMNIBUS_BALANCE' | 'UNDELIVERABLE_ADDRESS' | 'DELINQUENT_CLAIMS'>} [types] 
     * @param {Set<'SUMMARY' | 'BREAKDOWN'>} [groupTypes] 
     * @param {Set<'ACTIVE' | 'DEACTIVATED'>} [statuses] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getReportSchedulerPageRaw(requestParameters: GetReportSchedulerPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageReportSchedulerResponseDto>>;

    /**
     * Get Report Scheduler page
     */
    getReportSchedulerPage(requestParameters: GetReportSchedulerPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageReportSchedulerResponseDto>;

    /**
     * 
     * @summary Get total claim spend per plan for ER dashboard
     * @param {number} planYearId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getTotalClaimSpendRaw(requestParameters: GetTotalClaimSpendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ITotalClaimSpendResponseDto>>>;

    /**
     * Get total claim spend per plan for ER dashboard
     */
    getTotalClaimSpend(requestParameters: GetTotalClaimSpendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ITotalClaimSpendResponseDto>>;

    /**
     * 
     * @summary Get monthly claim spend breakdown by plan
     * @param {number} planId 
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getTotalMonthlyClaimSpendBreakdownRaw(requestParameters: GetTotalMonthlyClaimSpendBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<INotionalPlanBalanceMonthlyBreakdownResponseDto>>;

    /**
     * Get monthly claim spend breakdown by plan
     */
    getTotalMonthlyClaimSpendBreakdown(requestParameters: GetTotalMonthlyClaimSpendBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<INotionalPlanBalanceMonthlyBreakdownResponseDto>;

    /**
     * 
     * @summary Get Undeliverable Mail Report Breakdown
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {Set<'A' | 'T' | 'L' | 'R' | 'F' | 'C'>} [employmentStatuses] 
     * @param {boolean} [showSsn] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getUndeliverableAddressReportBreakdownRaw(requestParameters: GetUndeliverableAddressReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoUndeliverableAddressBreakdownRecordDto>>;

    /**
     * Get Undeliverable Mail Report Breakdown
     */
    getUndeliverableAddressReportBreakdown(requestParameters: GetUndeliverableAddressReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoUndeliverableAddressBreakdownRecordDto>;

    /**
     * 
     * @summary Generate Undeliverable Mail Report Breakdown CSV
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {number} [employerId] 
     * @param {Set<number>} [employerIds] 
     * @param {string} [searchValue] 
     * @param {Set<'A' | 'T' | 'L' | 'R' | 'F' | 'C'>} [employmentStatuses] 
     * @param {boolean} [showSsn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getUndeliverableAddressReportBreakdownCsvRaw(requestParameters: GetUndeliverableAddressReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Generate Undeliverable Mail Report Breakdown CSV
     */
    getUndeliverableAddressReportBreakdownCsv(requestParameters: GetUndeliverableAddressReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get Undeliverable Mail Report Brief
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getUndeliverableAddressReportBriefRaw(requestParameters: GetUndeliverableAddressReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IUndeliverableAddressBriefRecordDto>>;

    /**
     * Get Undeliverable Mail Report Brief
     */
    getUndeliverableAddressReportBrief(requestParameters: GetUndeliverableAddressReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IUndeliverableAddressBriefRecordDto>;

    /**
     * 
     * @summary Get undeliverable mail metrics for ER dashboard
     * @param {string} [observedOrganizationPath] Organization observing path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    getUndeliverableMailMetricsRaw(requestParameters: GetUndeliverableMailMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IUndeliverableMailMetricsResponseDto>>;

    /**
     * Get undeliverable mail metrics for ER dashboard
     */
    getUndeliverableMailMetrics(requestParameters: GetUndeliverableMailMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IUndeliverableMailMetricsResponseDto>;

    /**
     * 
     * @summary Update Report Scheduler
     * @param {number} id 
     * @param {IReportSchedulerUpdateDto} iReportSchedulerUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    updateReportSchedulerRaw(requestParameters: UpdateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSchedulerResponseDto>>;

    /**
     * Update Report Scheduler
     */
    updateReportScheduler(requestParameters: UpdateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSchedulerResponseDto>;

    /**
     * 
     * @summary Upsert Report Preferences
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportServiceServiceApiInterface
     */
    upsertReportPreferencesRaw(requestParameters: UpsertReportPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Upsert Report Preferences
     */
    upsertReportPreferences(requestParameters: UpsertReportPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

}

/**
 * 
 */
export class ReportServiceServiceApi extends runtime.BaseAPI implements ReportServiceServiceApiInterface {

    /**
     * Create Report Scheduler
     */
    async createReportSchedulerRaw(requestParameters: CreateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSchedulerResponseDto>> {
        if (requestParameters['iReportSchedulerCreateDto'] == null) {
            throw new runtime.RequiredError(
                'iReportSchedulerCreateDto',
                'Required parameter "iReportSchedulerCreateDto" was null or undefined when calling createReportScheduler().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/schedulers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IReportSchedulerCreateDtoToJSON(requestParameters['iReportSchedulerCreateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSchedulerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create Report Scheduler
     */
    async createReportScheduler(requestParameters: CreateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSchedulerResponseDto> {
        const response = await this.createReportSchedulerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate Report Scheduler
     */
    async deactivateReportSchedulerRaw(requestParameters: DeactivateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSchedulerResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deactivateReportScheduler().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/schedulers/{id}/deactivate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSchedulerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Deactivate Report Scheduler
     */
    async deactivateReportScheduler(requestParameters: DeactivateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSchedulerResponseDto> {
        const response = await this.deactivateReportSchedulerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Report Result
     */
    async deleteReportResultRaw(requestParameters: DeleteReportResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteReportResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/results/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Report Result
     */
    async deleteReportResult(requestParameters: DeleteReportResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteReportResultRaw(requestParameters, initOverrides);
    }

    /**
     * Get plan years for Account Usage Total Spend section
     */
    async getAccountUsagePlanYearsRaw(requestParameters: GetAccountUsagePlanYearsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanYearResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/account-usage/plan-years`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanYearResponseDtoFromJSON));
    }

    /**
     * Get plan years for Account Usage Total Spend section
     */
    async getAccountUsagePlanYears(requestParameters: GetAccountUsagePlanYearsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanYearResponseDto>> {
        const response = await this.getAccountUsagePlanYearsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Card Status Multi-Employer Report Summary
     */
    async getCardStatusMultiEmployerSummaryRaw(requestParameters: GetCardStatusMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['cardStatusReportGroupType'] != null) {
            queryParameters['card_status_report_group_type'] = requestParameters['cardStatusReportGroupType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/card-status-report/multi-employers/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Card Status Multi-Employer Report Summary
     */
    async getCardStatusMultiEmployerSummary(requestParameters: GetCardStatusMultiEmployerSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoCardStatusMultiEmployersSummaryRecordDto> {
        const response = await this.getCardStatusMultiEmployerSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Card Status Multi-Employer Report Summary CSV
     */
    async getCardStatusMultiEmployerSummaryCsvRaw(requestParameters: GetCardStatusMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['cardStatusReportGroupType'] != null) {
            queryParameters['card_status_report_group_type'] = requestParameters['cardStatusReportGroupType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/card-status-report/multi-employers/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Card Status Multi-Employer Report Summary CSV
     */
    async getCardStatusMultiEmployerSummaryCsv(requestParameters: GetCardStatusMultiEmployerSummaryCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCardStatusMultiEmployerSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Card Status Report Breakdown
     */
    async getCardStatusReportBreakdownRaw(requestParameters: GetCardStatusReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoCardStatusBreakdownRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['isNotMailed'] != null) {
            queryParameters['is_not_mailed'] = requestParameters['isNotMailed'];
        }

        if (requestParameters['mailedStartDate'] != null) {
            queryParameters['mailed_start_date'] = (requestParameters['mailedStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['mailedEndDate'] != null) {
            queryParameters['mailed_end_date'] = (requestParameters['mailedEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cardStatuses'] != null) {
            queryParameters['card_statuses'] = requestParameters['cardStatuses'];
        }

        if (requestParameters['employmentStatuses'] != null) {
            queryParameters['employment_statuses'] = requestParameters['employmentStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/card-status-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoCardStatusBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Card Status Report Breakdown
     */
    async getCardStatusReportBreakdown(requestParameters: GetCardStatusReportBreakdownRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoCardStatusBreakdownRecordDto> {
        const response = await this.getCardStatusReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Card Status Breakdown CSV Report
     */
    async getCardStatusReportBreakdownCsvRaw(requestParameters: GetCardStatusReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['isNotMailed'] != null) {
            queryParameters['is_not_mailed'] = requestParameters['isNotMailed'];
        }

        if (requestParameters['mailedStartDate'] != null) {
            queryParameters['mailed_start_date'] = (requestParameters['mailedStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['mailedEndDate'] != null) {
            queryParameters['mailed_end_date'] = (requestParameters['mailedEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cardStatuses'] != null) {
            queryParameters['card_statuses'] = requestParameters['cardStatuses'];
        }

        if (requestParameters['employmentStatuses'] != null) {
            queryParameters['employment_statuses'] = requestParameters['employmentStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/card-status-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Card Status Breakdown CSV Report
     */
    async getCardStatusReportBreakdownCsv(requestParameters: GetCardStatusReportBreakdownCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCardStatusReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Card Status Report Brief
     */
    async getCardStatusReportBriefRaw(requestParameters: GetCardStatusReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardStatusBriefRecordDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/card-status-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICardStatusBriefRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Card Status Report Brief
     */
    async getCardStatusReportBrief(requestParameters: GetCardStatusReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardStatusBriefRecordDto> {
        const response = await this.getCardStatusReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Card Status Report Summary
     */
    async getCardStatusReportSummaryRaw(requestParameters: GetCardStatusReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoCardStatusSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getCardStatusReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['cardStatusReportGroupType'] != null) {
            queryParameters['card_status_report_group_type'] = requestParameters['cardStatusReportGroupType'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/card-status-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoCardStatusSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Card Status Report Summary
     */
    async getCardStatusReportSummary(requestParameters: GetCardStatusReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoCardStatusSummaryRecordDto> {
        const response = await this.getCardStatusReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Card Status Report Summary CSV
     */
    async getCardStatusReportSummaryCsvRaw(requestParameters: GetCardStatusReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getCardStatusReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['cardStatusReportGroupType'] != null) {
            queryParameters['card_status_report_group_type'] = requestParameters['cardStatusReportGroupType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/card-status-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Card Status Report Summary CSV
     */
    async getCardStatusReportSummaryCsv(requestParameters: GetCardStatusReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCardStatusReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get CIP config metrics for ER dashboard
     */
    async getCipConfigMetricsRaw(requestParameters: GetCipConfigMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipConfigMetricsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/cip-config`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICipConfigMetricsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get CIP config metrics for ER dashboard
     */
    async getCipConfigMetrics(requestParameters: GetCipConfigMetricsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipConfigMetricsResponseDto> {
        const response = await this.getCipConfigMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get CIP info metrics for ER dashboard
     */
    async getCipInfoMetricsRaw(requestParameters: GetCipInfoMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipInfoMetricsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/cip-info`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICipInfoMetricsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get CIP info metrics for ER dashboard
     */
    async getCipInfoMetrics(requestParameters: GetCipInfoMetricsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipInfoMetricsResponseDto> {
        const response = await this.getCipInfoMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get CIP status Report Breakdown
     */
    async getCipStatusReportBreakdownRaw(requestParameters: GetCipStatusReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoCipStatusBreakdownRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['cipStatusStartDate'] != null) {
            queryParameters['cip_status_start_date'] = (requestParameters['cipStatusStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cipStatusEndDate'] != null) {
            queryParameters['cip_status_end_date'] = (requestParameters['cipStatusEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['employmentStatuses'] != null) {
            queryParameters['employment_statuses'] = requestParameters['employmentStatuses'];
        }

        if (requestParameters['accountStatuses'] != null) {
            queryParameters['account_statuses'] = requestParameters['accountStatuses'];
        }

        if (requestParameters['enrollmentStatuses'] != null) {
            queryParameters['enrollment_statuses'] = requestParameters['enrollmentStatuses'];
        }

        if (requestParameters['cipStatuses'] != null) {
            queryParameters['cip_statuses'] = requestParameters['cipStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/cip-status-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoCipStatusBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get CIP status Report Breakdown
     */
    async getCipStatusReportBreakdown(requestParameters: GetCipStatusReportBreakdownRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoCipStatusBreakdownRecordDto> {
        const response = await this.getCipStatusReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate CIP status Breakdown CSV Report
     */
    async getCipStatusReportBreakdownCsvRaw(requestParameters: GetCipStatusReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['cipStatusStartDate'] != null) {
            queryParameters['cip_status_start_date'] = (requestParameters['cipStatusStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cipStatusEndDate'] != null) {
            queryParameters['cip_status_end_date'] = (requestParameters['cipStatusEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['employmentStatuses'] != null) {
            queryParameters['employment_statuses'] = requestParameters['employmentStatuses'];
        }

        if (requestParameters['accountStatuses'] != null) {
            queryParameters['account_statuses'] = requestParameters['accountStatuses'];
        }

        if (requestParameters['enrollmentStatuses'] != null) {
            queryParameters['enrollment_statuses'] = requestParameters['enrollmentStatuses'];
        }

        if (requestParameters['cipStatuses'] != null) {
            queryParameters['cip_statuses'] = requestParameters['cipStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/cip-status-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate CIP status Breakdown CSV Report
     */
    async getCipStatusReportBreakdownCsv(requestParameters: GetCipStatusReportBreakdownCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCipStatusReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get CIP status Report Brief
     */
    async getCipStatusReportBriefRaw(requestParameters: GetCipStatusReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICipStatusBriefDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/cip-status-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICipStatusBriefDtoFromJSON(jsonValue));
    }

    /**
     * Get CIP status Report Brief
     */
    async getCipStatusReportBrief(requestParameters: GetCipStatusReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICipStatusBriefDto> {
        const response = await this.getCipStatusReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate CIP status Report Multi-Employers Summary CSV
     */
    async getCipStatusReportMultiEmployersSummaryCsvRaw(requestParameters: GetCipStatusReportMultiEmployersSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/cip-status-report/multi-employers/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate CIP status Report Multi-Employers Summary CSV
     */
    async getCipStatusReportMultiEmployersSummaryCsv(requestParameters: GetCipStatusReportMultiEmployersSummaryCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCipStatusReportMultiEmployersSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get CIP status Report Summary
     */
    async getCipStatusReportSummaryRaw(requestParameters: GetCipStatusReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoCipStatusSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getCipStatusReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/cip-status-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoCipStatusSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get CIP status Report Summary
     */
    async getCipStatusReportSummary(requestParameters: GetCipStatusReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoCipStatusSummaryRecordDto> {
        const response = await this.getCipStatusReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate CIP status Report Summary CSV
     */
    async getCipStatusReportSummaryCsvRaw(requestParameters: GetCipStatusReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getCipStatusReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/cip-status-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate CIP status Report Summary CSV
     */
    async getCipStatusReportSummaryCsv(requestParameters: GetCipStatusReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getCipStatusReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Claim Activity Multi-Employer Report Summary
     */
    async getClaimActivityMultiEmployerSummaryRaw(requestParameters: GetClaimActivityMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoClaimActivityMultiEmployersSummaryRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['claimStatuses'] != null) {
            queryParameters['claim_statuses'] = requestParameters['claimStatuses'];
        }

        if (requestParameters['claimTypes'] != null) {
            queryParameters['claim_types'] = requestParameters['claimTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/claim-activity-report/multi-employers/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportMultiEmployersSummaryPageDtoClaimActivityMultiEmployersSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Claim Activity Multi-Employer Report Summary
     */
    async getClaimActivityMultiEmployerSummary(requestParameters: GetClaimActivityMultiEmployerSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoClaimActivityMultiEmployersSummaryRecordDto> {
        const response = await this.getClaimActivityMultiEmployerSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Claim Activity Multi-Employer Report Summary CSV
     */
    async getClaimActivityMultiEmployerSummaryCsvRaw(requestParameters: GetClaimActivityMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['claimStatuses'] != null) {
            queryParameters['claim_statuses'] = requestParameters['claimStatuses'];
        }

        if (requestParameters['claimTypes'] != null) {
            queryParameters['claim_types'] = requestParameters['claimTypes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/claim-activity-report/multi-employers/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Claim Activity Multi-Employer Report Summary CSV
     */
    async getClaimActivityMultiEmployerSummaryCsv(requestParameters: GetClaimActivityMultiEmployerSummaryCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getClaimActivityMultiEmployerSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Claim Activity Report Breakdown
     */
    async getClaimActivityReportBreakdownRaw(requestParameters: GetClaimActivityReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoClaimActivityBreakdownRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['claimSubmitStartDate'] != null) {
            queryParameters['claim_submit_start_date'] = (requestParameters['claimSubmitStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['claimSubmitEndDate'] != null) {
            queryParameters['claim_submit_end_date'] = (requestParameters['claimSubmitEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['claimPaidStartDate'] != null) {
            queryParameters['claim_paid_start_date'] = (requestParameters['claimPaidStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['claimPaidEndDate'] != null) {
            queryParameters['claim_paid_end_date'] = (requestParameters['claimPaidEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['claimTypes'] != null) {
            queryParameters['claim_types'] = requestParameters['claimTypes'];
        }

        if (requestParameters['claimStatuses'] != null) {
            queryParameters['claim_statuses'] = requestParameters['claimStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/claim-activity-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoClaimActivityBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Claim Activity Report Breakdown
     */
    async getClaimActivityReportBreakdown(requestParameters: GetClaimActivityReportBreakdownRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoClaimActivityBreakdownRecordDto> {
        const response = await this.getClaimActivityReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Claim Activity Breakdown CSV Report
     */
    async getClaimActivityReportBreakdownCsvRaw(requestParameters: GetClaimActivityReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['claimSubmitStartDate'] != null) {
            queryParameters['claim_submit_start_date'] = (requestParameters['claimSubmitStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['claimSubmitEndDate'] != null) {
            queryParameters['claim_submit_end_date'] = (requestParameters['claimSubmitEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['claimPaidStartDate'] != null) {
            queryParameters['claim_paid_start_date'] = (requestParameters['claimPaidStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['claimPaidEndDate'] != null) {
            queryParameters['claim_paid_end_date'] = (requestParameters['claimPaidEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['claimTypes'] != null) {
            queryParameters['claim_types'] = requestParameters['claimTypes'];
        }

        if (requestParameters['claimStatuses'] != null) {
            queryParameters['claim_statuses'] = requestParameters['claimStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/claim-activity-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Claim Activity Breakdown CSV Report
     */
    async getClaimActivityReportBreakdownCsv(requestParameters: GetClaimActivityReportBreakdownCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getClaimActivityReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Claim Activity Report Brief
     */
    async getClaimActivityReportBriefRaw(requestParameters: GetClaimActivityReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimActivityBriefDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/claim-activity-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimActivityBriefDtoFromJSON(jsonValue));
    }

    /**
     * Get Claim Activity Report Brief
     */
    async getClaimActivityReportBrief(requestParameters: GetClaimActivityReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimActivityBriefDto> {
        const response = await this.getClaimActivityReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Claim Activity Report Summary
     */
    async getClaimActivityReportSummaryRaw(requestParameters: GetClaimActivityReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoClaimActivitySummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getClaimActivityReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['claimStatuses'] != null) {
            queryParameters['claim_statuses'] = requestParameters['claimStatuses'];
        }

        if (requestParameters['claimTypes'] != null) {
            queryParameters['claim_types'] = requestParameters['claimTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/claim-activity-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoClaimActivitySummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Claim Activity Report Summary
     */
    async getClaimActivityReportSummary(requestParameters: GetClaimActivityReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoClaimActivitySummaryRecordDto> {
        const response = await this.getClaimActivityReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Claim Activity Report Summary CSV
     */
    async getClaimActivityReportSummaryCsvRaw(requestParameters: GetClaimActivityReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getClaimActivityReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['claimStatuses'] != null) {
            queryParameters['claim_statuses'] = requestParameters['claimStatuses'];
        }

        if (requestParameters['claimTypes'] != null) {
            queryParameters['claim_types'] = requestParameters['claimTypes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/claim-activity-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Claim Activity Report Summary CSV
     */
    async getClaimActivityReportSummaryCsv(requestParameters: GetClaimActivityReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getClaimActivityReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get claim spend breakdown for Account Usage Details page
     */
    async getClaimDetailsRaw(requestParameters: GetClaimDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimDetailsResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getClaimDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-usage/plans/{planId}/claim-details`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get claim spend breakdown for Account Usage Details page
     */
    async getClaimDetails(requestParameters: GetClaimDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimDetailsResponseDto> {
        const response = await this.getClaimDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get claims substantiation rate metrics for ER dashboard
     */
    async getClaimsSubstantiationRateMetricsRaw(requestParameters: GetClaimsSubstantiationRateMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimsSubstantiationRateMetricsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/claims-substantiation-rate`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimsSubstantiationRateMetricsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get claims substantiation rate metrics for ER dashboard
     */
    async getClaimsSubstantiationRateMetrics(requestParameters: GetClaimsSubstantiationRateMetricsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimsSubstantiationRateMetricsResponseDto> {
        const response = await this.getClaimsSubstantiationRateMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Contribution Invoice Report Breakdown
     */
    async getContributionInvoiceReportBreakdownRaw(requestParameters: GetContributionInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoContributionInvoiceBreakdownRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getContributionInvoiceReportBreakdown().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/contribution-invoice-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoContributionInvoiceBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Contribution Invoice Report Breakdown
     */
    async getContributionInvoiceReportBreakdown(requestParameters: GetContributionInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoContributionInvoiceBreakdownRecordDto> {
        const response = await this.getContributionInvoiceReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Contribution Invoice Breakdown CSV Report
     */
    async getContributionInvoiceReportBreakdownCsvRaw(requestParameters: GetContributionInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getContributionInvoiceReportBreakdownCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/contribution-invoice-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Contribution Invoice Breakdown CSV Report
     */
    async getContributionInvoiceReportBreakdownCsv(requestParameters: GetContributionInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getContributionInvoiceReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Contribution Invoice Report Brief
     */
    async getContributionInvoiceReportBriefRaw(requestParameters: GetContributionInvoiceReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceBriefRecordDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/contribution-invoice-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvoiceBriefRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Contribution Invoice Report Brief
     */
    async getContributionInvoiceReportBrief(requestParameters: GetContributionInvoiceReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceBriefRecordDto> {
        const response = await this.getContributionInvoiceReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Contribution Invoice Report Summary
     */
    async getContributionInvoiceReportSummaryRaw(requestParameters: GetContributionInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoInvoiceSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getContributionInvoiceReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/contribution-invoice-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoInvoiceSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Contribution Invoice Report Summary
     */
    async getContributionInvoiceReportSummary(requestParameters: GetContributionInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoInvoiceSummaryRecordDto> {
        const response = await this.getContributionInvoiceReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Contribution Invoice Report Summary CSV
     */
    async getContributionInvoiceReportSummaryCsvRaw(requestParameters: GetContributionInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getContributionInvoiceReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/contribution-invoice-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Contribution Invoice Report Summary CSV
     */
    async getContributionInvoiceReportSummaryCsv(requestParameters: GetContributionInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getContributionInvoiceReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get delinquent claims metrics for ER dashboard
     */
    async getDelinquentClaimsMetricsRaw(requestParameters: GetDelinquentClaimsMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDelinquentClaimsMetricsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/delinquent-claims`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDelinquentClaimsMetricsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get delinquent claims metrics for ER dashboard
     */
    async getDelinquentClaimsMetrics(requestParameters: GetDelinquentClaimsMetricsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDelinquentClaimsMetricsResponseDto> {
        const response = await this.getDelinquentClaimsMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Delinquent Claims Multi-Employer Report Summary
     */
    async getDelinquentClaimsMultiEmployerSummaryRaw(requestParameters: GetDelinquentClaimsMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoDelinquentClaimsMultiEmployersSummaryRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['accountTypes'] != null) {
            queryParameters['account_types'] = requestParameters['accountTypes'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/delinquent-claims-report/multi-employers/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportMultiEmployersSummaryPageDtoDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Delinquent Claims Multi-Employer Report Summary
     */
    async getDelinquentClaimsMultiEmployerSummary(requestParameters: GetDelinquentClaimsMultiEmployerSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoDelinquentClaimsMultiEmployersSummaryRecordDto> {
        const response = await this.getDelinquentClaimsMultiEmployerSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Delinquent Claims Multi-Employer Report Summary CSV
     */
    async getDelinquentClaimsMultiEmployerSummaryCsvRaw(requestParameters: GetDelinquentClaimsMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['accountTypes'] != null) {
            queryParameters['account_types'] = requestParameters['accountTypes'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/delinquent-claims-report/multi-employers/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Delinquent Claims Multi-Employer Report Summary CSV
     */
    async getDelinquentClaimsMultiEmployerSummaryCsv(requestParameters: GetDelinquentClaimsMultiEmployerSummaryCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getDelinquentClaimsMultiEmployerSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Delinquent Claims Report Breakdown
     */
    async getDelinquentClaimsReportBreakdownRaw(requestParameters: GetDelinquentClaimsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoBaseBreakdownRecordDto>> {
        if (requestParameters['delinquentClaimsViewType'] == null) {
            throw new runtime.RequiredError(
                'delinquentClaimsViewType',
                'Required parameter "delinquentClaimsViewType" was null or undefined when calling getDelinquentClaimsReportBreakdown().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['delinquentClaimsViewType'] != null) {
            queryParameters['delinquent_claims_view_type'] = requestParameters['delinquentClaimsViewType'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriods'] != null) {
            queryParameters['plan_year_periods'] = requestParameters['planYearPeriods'];
        }

        if (requestParameters['accountTypes'] != null) {
            queryParameters['account_types'] = requestParameters['accountTypes'];
        }

        if (requestParameters['claimStatuses'] != null) {
            queryParameters['claim_statuses'] = requestParameters['claimStatuses'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/delinquent-claims-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoBaseBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Delinquent Claims Report Breakdown
     */
    async getDelinquentClaimsReportBreakdown(requestParameters: GetDelinquentClaimsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoBaseBreakdownRecordDto> {
        const response = await this.getDelinquentClaimsReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Delinquent Claims Report Breakdown CSV
     */
    async getDelinquentClaimsReportBreakdownCsvRaw(requestParameters: GetDelinquentClaimsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['delinquentClaimsViewType'] == null) {
            throw new runtime.RequiredError(
                'delinquentClaimsViewType',
                'Required parameter "delinquentClaimsViewType" was null or undefined when calling getDelinquentClaimsReportBreakdownCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['delinquentClaimsViewType'] != null) {
            queryParameters['delinquent_claims_view_type'] = requestParameters['delinquentClaimsViewType'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriods'] != null) {
            queryParameters['planYearPeriods'] = requestParameters['planYearPeriods'];
        }

        if (requestParameters['accountTypes'] != null) {
            queryParameters['account_types'] = requestParameters['accountTypes'];
        }

        if (requestParameters['claimStatuses'] != null) {
            queryParameters['claim_statuses'] = requestParameters['claimStatuses'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/delinquent-claims-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Delinquent Claims Report Breakdown CSV
     */
    async getDelinquentClaimsReportBreakdownCsv(requestParameters: GetDelinquentClaimsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getDelinquentClaimsReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Delinquent Claims Report Brief
     */
    async getDelinquentClaimsReportBriefRaw(requestParameters: GetDelinquentClaimsReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IDelinquentClaimsBriefDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/delinquent-claims-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IDelinquentClaimsBriefDtoFromJSON(jsonValue));
    }

    /**
     * Get Delinquent Claims Report Brief
     */
    async getDelinquentClaimsReportBrief(requestParameters: GetDelinquentClaimsReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IDelinquentClaimsBriefDto> {
        const response = await this.getDelinquentClaimsReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Delinquent Claims Report Single Employer Summary
     */
    async getDelinquentClaimsReportSummaryRaw(requestParameters: GetDelinquentClaimsReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoDelinquentClaimsSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getDelinquentClaimsReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['accountTypes'] != null) {
            queryParameters['account_types'] = requestParameters['accountTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/delinquent-claims-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoDelinquentClaimsSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Delinquent Claims Report Single Employer Summary
     */
    async getDelinquentClaimsReportSummary(requestParameters: GetDelinquentClaimsReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoDelinquentClaimsSummaryRecordDto> {
        const response = await this.getDelinquentClaimsReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Delinquent Claims Report Single Employer Summary CSV
     */
    async getDelinquentClaimsReportSummaryCsvRaw(requestParameters: GetDelinquentClaimsReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getDelinquentClaimsReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['accountTypes'] != null) {
            queryParameters['account_types'] = requestParameters['accountTypes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/delinquent-claims-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Delinquent Claims Report Single Employer Summary CSV
     */
    async getDelinquentClaimsReportSummaryCsv(requestParameters: GetDelinquentClaimsReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getDelinquentClaimsReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Employee Demographics Report Breakdown
     */
    async getEmployeeDemographicsReportBreakdownRaw(requestParameters: GetEmployeeDemographicsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoEmployeeDemographicsBreakdownRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['employmentStatuses'] != null) {
            queryParameters['employment_statuses'] = requestParameters['employmentStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/employee-demographics-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoEmployeeDemographicsBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Employee Demographics Report Breakdown
     */
    async getEmployeeDemographicsReportBreakdown(requestParameters: GetEmployeeDemographicsReportBreakdownRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoEmployeeDemographicsBreakdownRecordDto> {
        const response = await this.getEmployeeDemographicsReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Employee Demographics Report Breakdown CSV
     */
    async getEmployeeDemographicsReportBreakdownCsvRaw(requestParameters: GetEmployeeDemographicsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['employmentStatuses'] != null) {
            queryParameters['employment_statuses'] = requestParameters['employmentStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/employee-demographics-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Employee Demographics Report Breakdown CSV
     */
    async getEmployeeDemographicsReportBreakdownCsv(requestParameters: GetEmployeeDemographicsReportBreakdownCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getEmployeeDemographicsReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get total employee metrics for ER dashboard
     */
    async getEmployeeMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployeeMetricsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/employees`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployeeMetricsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get total employee metrics for ER dashboard
     */
    async getEmployeeMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployeeMetricsResponseDto> {
        const response = await this.getEmployeeMetricsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get employer calendar events
     */
    async getEmployerCalendarEventsRaw(requestParameters: GetEmployerCalendarEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IEmployerCalendarEventsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['fromDate'] != null) {
            queryParameters['from_date'] = (requestParameters['fromDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['toDate'] != null) {
            queryParameters['to_date'] = (requestParameters['toDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['categories'] != null) {
            queryParameters['categories'] = requestParameters['categories'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/employer-calendar-events`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IEmployerCalendarEventsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get employer calendar events
     */
    async getEmployerCalendarEvents(requestParameters: GetEmployerCalendarEventsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IEmployerCalendarEventsResponseDto> {
        const response = await this.getEmployerCalendarEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Forfeiture Report Breakdown
     */
    async getForfeitureReportBreakdownRaw(requestParameters: GetForfeitureReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoBaseBreakdownRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getForfeitureReportBreakdown().'
            );
        }

        if (requestParameters['forfeitureReportGroup'] == null) {
            throw new runtime.RequiredError(
                'forfeitureReportGroup',
                'Required parameter "forfeitureReportGroup" was null or undefined when calling getForfeitureReportBreakdown().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['forfeitureReportGroup'] != null) {
            queryParameters['forfeiture_report_group'] = requestParameters['forfeitureReportGroup'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/forfeiture-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoBaseBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Forfeiture Report Breakdown
     */
    async getForfeitureReportBreakdown(requestParameters: GetForfeitureReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoBaseBreakdownRecordDto> {
        const response = await this.getForfeitureReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Forfeiture Report Breakdown CSV
     */
    async getForfeitureReportBreakdownCsvRaw(requestParameters: GetForfeitureReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getForfeitureReportBreakdownCsv().'
            );
        }

        if (requestParameters['forfeitureReportGroup'] == null) {
            throw new runtime.RequiredError(
                'forfeitureReportGroup',
                'Required parameter "forfeitureReportGroup" was null or undefined when calling getForfeitureReportBreakdownCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['forfeitureReportGroup'] != null) {
            queryParameters['forfeiture_report_group'] = requestParameters['forfeitureReportGroup'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/forfeiture-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Forfeiture Report Breakdown CSV
     */
    async getForfeitureReportBreakdownCsv(requestParameters: GetForfeitureReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getForfeitureReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Forfeiture Report Summary
     */
    async getForfeitureReportSummaryRaw(requestParameters: GetForfeitureReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoForfeitureSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getForfeitureReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/forfeiture-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoForfeitureSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Forfeiture Report Summary
     */
    async getForfeitureReportSummary(requestParameters: GetForfeitureReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoForfeitureSummaryRecordDto> {
        const response = await this.getForfeitureReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Forfeiture Report Summary CSV
     */
    async getForfeitureReportSummaryCsvRaw(requestParameters: GetForfeitureReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getForfeitureReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/forfeiture-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Forfeiture Report Summary CSV
     */
    async getForfeitureReportSummaryCsv(requestParameters: GetForfeitureReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getForfeitureReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get fraud review required metrics for ER dashboard
     */
    async getFraudReviewRequiredMetricsRaw(requestParameters: GetFraudReviewRequiredMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IFraudReviewRequiredMetricsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/fraud-review-required`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IFraudReviewRequiredMetricsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get fraud review required metrics for ER dashboard
     */
    async getFraudReviewRequiredMetrics(requestParameters: GetFraudReviewRequiredMetricsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IFraudReviewRequiredMetricsResponseDto> {
        const response = await this.getFraudReviewRequiredMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Health Plan Enrollment Report Breakdown
     */
    async getHealthPlanEnrollmentReportBreakdownRaw(requestParameters: GetHealthPlanEnrollmentReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoHealthPlanEnrollmentBreakdownRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/health-plan-enrollment-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoHealthPlanEnrollmentBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Health Plan Enrollment Report Breakdown
     */
    async getHealthPlanEnrollmentReportBreakdown(requestParameters: GetHealthPlanEnrollmentReportBreakdownRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoHealthPlanEnrollmentBreakdownRecordDto> {
        const response = await this.getHealthPlanEnrollmentReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Health Plan Enrollment Report Breakdown CSV
     */
    async getHealthPlanEnrollmentReportBreakdownCsvRaw(requestParameters: GetHealthPlanEnrollmentReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/health-plan-enrollment-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Health Plan Enrollment Report Breakdown CSV
     */
    async getHealthPlanEnrollmentReportBreakdownCsv(requestParameters: GetHealthPlanEnrollmentReportBreakdownCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getHealthPlanEnrollmentReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Health Plan Enrollment Report Brief
     */
    async getHealthPlanEnrollmentReportBriefRaw(requestParameters: GetHealthPlanEnrollmentReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHealthPlanEnrollmentBriefDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/health-plan-enrollment-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IHealthPlanEnrollmentBriefDtoFromJSON(jsonValue));
    }

    /**
     * Get Health Plan Enrollment Report Brief
     */
    async getHealthPlanEnrollmentReportBrief(requestParameters: GetHealthPlanEnrollmentReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHealthPlanEnrollmentBriefDto> {
        const response = await this.getHealthPlanEnrollmentReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Health Plan Enrollment Report Summary
     */
    async getHealthPlanEnrollmentReportSummaryRaw(requestParameters: GetHealthPlanEnrollmentReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getHealthPlanEnrollmentReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/health-plan-enrollment-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Health Plan Enrollment Report Summary
     */
    async getHealthPlanEnrollmentReportSummary(requestParameters: GetHealthPlanEnrollmentReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoHealthPlanEnrollmentSummaryRecordDto> {
        const response = await this.getHealthPlanEnrollmentReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Health Plan Enrollment Report Summary CSV
     */
    async getHealthPlanEnrollmentReportSummaryCsvRaw(requestParameters: GetHealthPlanEnrollmentReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getHealthPlanEnrollmentReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/health-plan-enrollment-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Health Plan Enrollment Report Summary CSV
     */
    async getHealthPlanEnrollmentReportSummaryCsv(requestParameters: GetHealthPlanEnrollmentReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getHealthPlanEnrollmentReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get HSA cash and investment balance breakdown for Account Usage Details page
     */
    async getHsaBalancesRaw(requestParameters: GetHsaBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHsaPlanBalanceMonthlyBreakdownResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getHsaBalances().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-usage/plans/{planId}/balances/hsa`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IHsaPlanBalanceMonthlyBreakdownResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get HSA cash and investment balance breakdown for Account Usage Details page
     */
    async getHsaBalances(requestParameters: GetHsaBalancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHsaPlanBalanceMonthlyBreakdownResponseDto> {
        const response = await this.getHsaBalancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get HSA plan overview metrics
     */
    async getHsaOverviewRaw(requestParameters: GetHsaOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHsaOverviewResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getHsaOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-usage/plans/{planId}/overview/hsa`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IHsaOverviewResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get HSA plan overview metrics
     */
    async getHsaOverview(requestParameters: GetHsaOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHsaOverviewResponseDto> {
        const response = await this.getHsaOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get HSA plan details and deadlines
     */
    async getHsaPlanDetailsRaw(requestParameters: GetHsaPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IHsaDetailsResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getHsaPlanDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-usage/plans/{planId}/plan-details/hsa`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IHsaDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get HSA plan details and deadlines
     */
    async getHsaPlanDetails(requestParameters: GetHsaPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IHsaDetailsResponseDto> {
        const response = await this.getHsaPlanDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get invoice plan level replenishment metrics for ER dashboard
     */
    async getInvoicePlanLevelReplenishmentMetricsRaw(requestParameters: GetInvoicePlanLevelReplenishmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IInvoicePlanLevelReplenishmentMetricsResponseDto>>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getInvoicePlanLevelReplenishmentMetrics().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getInvoicePlanLevelReplenishmentMetrics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/invoice-plan-level-replenishment`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IInvoicePlanLevelReplenishmentMetricsResponseDtoFromJSON));
    }

    /**
     * Get invoice plan level replenishment metrics for ER dashboard
     */
    async getInvoicePlanLevelReplenishmentMetrics(requestParameters: GetInvoicePlanLevelReplenishmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IInvoicePlanLevelReplenishmentMetricsResponseDto>> {
        const response = await this.getInvoicePlanLevelReplenishmentMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get invoice replenishment metrics for ER dashboard
     */
    async getInvoiceReplenishmentMetricsRaw(requestParameters: GetInvoiceReplenishmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceReplenishmentMetricsResponseDto>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getInvoiceReplenishmentMetrics().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getInvoiceReplenishmentMetrics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/invoice-replenishment`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvoiceReplenishmentMetricsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get invoice replenishment metrics for ER dashboard
     */
    async getInvoiceReplenishmentMetrics(requestParameters: GetInvoiceReplenishmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceReplenishmentMetricsResponseDto> {
        const response = await this.getInvoiceReplenishmentMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get notional plan overview metrics
     */
    async getNotionalOverviewRaw(requestParameters: GetNotionalOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<INotionalOverviewResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getNotionalOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-usage/plans/{planId}/overview/notional`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => INotionalOverviewResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get notional plan overview metrics
     */
    async getNotionalOverview(requestParameters: GetNotionalOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<INotionalOverviewResponseDto> {
        const response = await this.getNotionalOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get notional plan details and deadlines
     */
    async getNotionalPlanDetailsRaw(requestParameters: GetNotionalPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<INotionalDetailsResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getNotionalPlanDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-usage/plans/{planId}/plan-details/notional`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => INotionalDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get notional plan details and deadlines
     */
    async getNotionalPlanDetails(requestParameters: GetNotionalPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<INotionalDetailsResponseDto> {
        const response = await this.getNotionalPlanDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get PAA Multi-Employer Report Summary
     */
    async getPaaMultiEmployerSummaryRaw(requestParameters: GetPaaMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoParticipantAccountActivityMultiEmployersSummaryRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/participant-account-activity-report/multi-employers/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportMultiEmployersSummaryPageDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get PAA Multi-Employer Report Summary
     */
    async getPaaMultiEmployerSummary(requestParameters: GetPaaMultiEmployerSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoParticipantAccountActivityMultiEmployersSummaryRecordDto> {
        const response = await this.getPaaMultiEmployerSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate PAA Multi-Employer Report Summary CSV
     */
    async getPaaMultiEmployerSummaryCsvRaw(requestParameters: GetPaaMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/participant-account-activity-report/multi-employers/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate PAA Multi-Employer Report Summary CSV
     */
    async getPaaMultiEmployerSummaryCsv(requestParameters: GetPaaMultiEmployerSummaryCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPaaMultiEmployerSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Participant Account Activity Report Breakdown
     */
    async getParticipantAccountActivityReportBreakdownRaw(requestParameters: GetParticipantAccountActivityReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoParticipantAccountActivityBreakdownRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['asOfDate'] != null) {
            queryParameters['as_of_date'] = (requestParameters['asOfDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['enrollmentStatuses'] != null) {
            queryParameters['enrollment_statuses'] = requestParameters['enrollmentStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['accountTypes'] != null) {
            queryParameters['account_types'] = requestParameters['accountTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/participant-account-activity-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoParticipantAccountActivityBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Participant Account Activity Report Breakdown
     */
    async getParticipantAccountActivityReportBreakdown(requestParameters: GetParticipantAccountActivityReportBreakdownRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoParticipantAccountActivityBreakdownRecordDto> {
        const response = await this.getParticipantAccountActivityReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Participant Account Activity Report Breakdown CSV
     */
    async getParticipantAccountActivityReportBreakdownCsvRaw(requestParameters: GetParticipantAccountActivityReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['asOfDate'] != null) {
            queryParameters['as_of_date'] = (requestParameters['asOfDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['enrollmentStatuses'] != null) {
            queryParameters['enrollment_statuses'] = requestParameters['enrollmentStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['accountTypes'] != null) {
            queryParameters['account_types'] = requestParameters['accountTypes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/participant-account-activity-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Participant Account Activity Report Breakdown CSV
     */
    async getParticipantAccountActivityReportBreakdownCsv(requestParameters: GetParticipantAccountActivityReportBreakdownCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getParticipantAccountActivityReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Participant Account Activity Report Brief
     */
    async getParticipantAccountActivityReportBriefRaw(requestParameters: GetParticipantAccountActivityReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IParticipantAccountActivityBriefDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/participant-account-activity-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IParticipantAccountActivityBriefDtoFromJSON(jsonValue));
    }

    /**
     * Get Participant Account Activity Report Brief
     */
    async getParticipantAccountActivityReportBrief(requestParameters: GetParticipantAccountActivityReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IParticipantAccountActivityBriefDto> {
        const response = await this.getParticipantAccountActivityReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Participant Account Activity Report Summary
     */
    async getParticipantAccountActivityReportSummaryRaw(requestParameters: GetParticipantAccountActivityReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getParticipantAccountActivityReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/participant-account-activity-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Participant Account Activity Report Summary
     */
    async getParticipantAccountActivityReportSummary(requestParameters: GetParticipantAccountActivityReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto> {
        const response = await this.getParticipantAccountActivityReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Participant Account Activity Report Summary CSV
     */
    async getParticipantAccountActivityReportSummaryCsvRaw(requestParameters: GetParticipantAccountActivityReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getParticipantAccountActivityReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/participant-account-activity-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Participant Account Activity Report Summary CSV
     */
    async getParticipantAccountActivityReportSummaryCsv(requestParameters: GetParticipantAccountActivityReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getParticipantAccountActivityReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Payroll Contributions Multi-Employer Report Summary
     */
    async getPayrollContributionsMultiEmployerSummaryRaw(requestParameters: GetPayrollContributionsMultiEmployerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoPayrollContributionsMultiEmployersSummaryRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/payroll-contributions-report/multi-employers/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportMultiEmployersSummaryPageDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Payroll Contributions Multi-Employer Report Summary
     */
    async getPayrollContributionsMultiEmployerSummary(requestParameters: GetPayrollContributionsMultiEmployerSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoPayrollContributionsMultiEmployersSummaryRecordDto> {
        const response = await this.getPayrollContributionsMultiEmployerSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Payroll Contributions Multi-Employer Report Summary CSV
     */
    async getPayrollContributionsMultiEmployerSummaryCsvRaw(requestParameters: GetPayrollContributionsMultiEmployerSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/payroll-contributions-report/multi-employers/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Payroll Contributions Multi-Employer Report Summary CSV
     */
    async getPayrollContributionsMultiEmployerSummaryCsv(requestParameters: GetPayrollContributionsMultiEmployerSummaryCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPayrollContributionsMultiEmployerSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Payroll Contributions Report Breakdown
     */
    async getPayrollContributionsReportBreakdownRaw(requestParameters: GetPayrollContributionsReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoPayrollContributionsBreakdownRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['contributionStartDate'] != null) {
            queryParameters['contribution_start_date'] = (requestParameters['contributionStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['contributionEndDate'] != null) {
            queryParameters['contribution_end_date'] = (requestParameters['contributionEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['transactionStartDate'] != null) {
            queryParameters['transaction_start_date'] = (requestParameters['transactionStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['transactionEndDate'] != null) {
            queryParameters['transaction_end_date'] = (requestParameters['transactionEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/payroll-contributions-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoPayrollContributionsBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Payroll Contributions Report Breakdown
     */
    async getPayrollContributionsReportBreakdown(requestParameters: GetPayrollContributionsReportBreakdownRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoPayrollContributionsBreakdownRecordDto> {
        const response = await this.getPayrollContributionsReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Payroll Contributions Report Breakdown CSV
     */
    async getPayrollContributionsReportBreakdownCsvRaw(requestParameters: GetPayrollContributionsReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['contributionStartDate'] != null) {
            queryParameters['contribution_start_date'] = (requestParameters['contributionStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['contributionEndDate'] != null) {
            queryParameters['contribution_end_date'] = (requestParameters['contributionEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['transactionStartDate'] != null) {
            queryParameters['transaction_start_date'] = (requestParameters['transactionStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['transactionEndDate'] != null) {
            queryParameters['transaction_end_date'] = (requestParameters['transactionEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/payroll-contributions-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Payroll Contributions Report Breakdown CSV
     */
    async getPayrollContributionsReportBreakdownCsv(requestParameters: GetPayrollContributionsReportBreakdownCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPayrollContributionsReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Payroll Contributions Report Summary
     */
    async getPayrollContributionsReportSummaryRaw(requestParameters: GetPayrollContributionsReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoPayrollContributionsSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPayrollContributionsReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/payroll-contributions-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoPayrollContributionsSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Payroll Contributions Report Summary
     */
    async getPayrollContributionsReportSummary(requestParameters: GetPayrollContributionsReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoPayrollContributionsSummaryRecordDto> {
        const response = await this.getPayrollContributionsReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Payroll Contributions Report Summary CSV
     */
    async getPayrollContributionsReportSummaryCsvRaw(requestParameters: GetPayrollContributionsReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPayrollContributionsReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/payroll-contributions-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Payroll Contributions Report Summary CSV
     */
    async getPayrollContributionsReportSummaryCsv(requestParameters: GetPayrollContributionsReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPayrollContributionsReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get plan enrollment metrics for ER dashboard
     */
    async getPlanEnrollmentMetricsRaw(requestParameters: GetPlanEnrollmentMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPlanEnrollmentMetricsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/plan-enrollment`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPlanEnrollmentMetricsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get plan enrollment metrics for ER dashboard
     */
    async getPlanEnrollmentMetrics(requestParameters: GetPlanEnrollmentMetricsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPlanEnrollmentMetricsResponseDto> {
        const response = await this.getPlanEnrollmentMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Plan Omnibus Balance Report Breakdown
     */
    async getPlanOmnibusBalanceReportBreakdownRaw(requestParameters: GetPlanOmnibusBalanceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoPlanOmnibusBalanceBreakdownRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPlanOmnibusBalanceReportBreakdown().'
            );
        }

        if (requestParameters['planIds'] == null) {
            throw new runtime.RequiredError(
                'planIds',
                'Required parameter "planIds" was null or undefined when calling getPlanOmnibusBalanceReportBreakdown().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/plan-omnibus-balance-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoPlanOmnibusBalanceBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Plan Omnibus Balance Report Breakdown
     */
    async getPlanOmnibusBalanceReportBreakdown(requestParameters: GetPlanOmnibusBalanceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoPlanOmnibusBalanceBreakdownRecordDto> {
        const response = await this.getPlanOmnibusBalanceReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Plan Omnibus Balance Report Breakdown CSV
     */
    async getPlanOmnibusBalanceReportBreakdownCsvRaw(requestParameters: GetPlanOmnibusBalanceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPlanOmnibusBalanceReportBreakdownCsv().'
            );
        }

        if (requestParameters['planIds'] == null) {
            throw new runtime.RequiredError(
                'planIds',
                'Required parameter "planIds" was null or undefined when calling getPlanOmnibusBalanceReportBreakdownCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/plan-omnibus-balance-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Plan Omnibus Balance Report Breakdown CSV
     */
    async getPlanOmnibusBalanceReportBreakdownCsv(requestParameters: GetPlanOmnibusBalanceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPlanOmnibusBalanceReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Plan Omnibus Balance Report Breakdown plans
     */
    async getPlanOmnibusBalanceReportBreakdownPlansRaw(requestParameters: GetPlanOmnibusBalanceReportBreakdownPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanDto>>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPlanOmnibusBalanceReportBreakdownPlans().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/plan-omnibus-balance-report/breakdown/plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanDtoFromJSON));
    }

    /**
     * Get Plan Omnibus Balance Report Breakdown plans
     */
    async getPlanOmnibusBalanceReportBreakdownPlans(requestParameters: GetPlanOmnibusBalanceReportBreakdownPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanDto>> {
        const response = await this.getPlanOmnibusBalanceReportBreakdownPlansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Plan Omnibus Balance Report Summary
     */
    async getPlanOmnibusBalanceReportSummaryRaw(requestParameters: GetPlanOmnibusBalanceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoPlanOmnibusBalanceSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPlanOmnibusBalanceReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/plan-omnibus-balance-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoPlanOmnibusBalanceSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Plan Omnibus Balance Report Summary
     */
    async getPlanOmnibusBalanceReportSummary(requestParameters: GetPlanOmnibusBalanceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoPlanOmnibusBalanceSummaryRecordDto> {
        const response = await this.getPlanOmnibusBalanceReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Plan Omnibus Balance Report Summary CSV
     */
    async getPlanOmnibusBalanceReportSummaryCsvRaw(requestParameters: GetPlanOmnibusBalanceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPlanOmnibusBalanceReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['planYearPeriod'] != null) {
            queryParameters['plan_year_period'] = requestParameters['planYearPeriod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/plan-omnibus-balance-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Plan Omnibus Balance Report Summary CSV
     */
    async getPlanOmnibusBalanceReportSummaryCsv(requestParameters: GetPlanOmnibusBalanceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPlanOmnibusBalanceReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get plans for Account Usage account selector
     */
    async getPlansRaw(requestParameters: GetPlansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IPlanResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-usage/plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IPlanResponseDtoFromJSON));
    }

    /**
     * Get plans for Account Usage account selector
     */
    async getPlans(requestParameters: GetPlansRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IPlanResponseDto>> {
        const response = await this.getPlansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Prefund Invoice Report Breakdown
     */
    async getPrefundInvoiceReportBreakdownRaw(requestParameters: GetPrefundInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoPrefundInvoiceBreakdownRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPrefundInvoiceReportBreakdown().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/prefund-invoice-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoPrefundInvoiceBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Prefund Invoice Report Breakdown
     */
    async getPrefundInvoiceReportBreakdown(requestParameters: GetPrefundInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoPrefundInvoiceBreakdownRecordDto> {
        const response = await this.getPrefundInvoiceReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Prefund Invoice Breakdown CSV Report
     */
    async getPrefundInvoiceReportBreakdownCsvRaw(requestParameters: GetPrefundInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPrefundInvoiceReportBreakdownCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/prefund-invoice-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Prefund Invoice Breakdown CSV Report
     */
    async getPrefundInvoiceReportBreakdownCsv(requestParameters: GetPrefundInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPrefundInvoiceReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Prefund Invoice Report Brief
     */
    async getPrefundInvoiceReportBriefRaw(requestParameters: GetPrefundInvoiceReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceBriefRecordDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/prefund-invoice-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvoiceBriefRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Prefund Invoice Report Brief
     */
    async getPrefundInvoiceReportBrief(requestParameters: GetPrefundInvoiceReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceBriefRecordDto> {
        const response = await this.getPrefundInvoiceReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Prefund Invoice Report Summary
     */
    async getPrefundInvoiceReportSummaryRaw(requestParameters: GetPrefundInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoInvoiceSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPrefundInvoiceReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/prefund-invoice-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoInvoiceSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Prefund Invoice Report Summary
     */
    async getPrefundInvoiceReportSummary(requestParameters: GetPrefundInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoInvoiceSummaryRecordDto> {
        const response = await this.getPrefundInvoiceReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Prefund Invoice Report Summary CSV
     */
    async getPrefundInvoiceReportSummaryCsvRaw(requestParameters: GetPrefundInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getPrefundInvoiceReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/prefund-invoice-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Prefund Invoice Report Summary CSV
     */
    async getPrefundInvoiceReportSummaryCsv(requestParameters: GetPrefundInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPrefundInvoiceReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Replenishment Invoice Report Breakdown
     */
    async getReplenishmentInvoiceReportBreakdownRaw(requestParameters: GetReplenishmentInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoReplenishmentInvoiceBreakdownRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getReplenishmentInvoiceReportBreakdown().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/replenishment-invoice-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoReplenishmentInvoiceBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Replenishment Invoice Report Breakdown
     */
    async getReplenishmentInvoiceReportBreakdown(requestParameters: GetReplenishmentInvoiceReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoReplenishmentInvoiceBreakdownRecordDto> {
        const response = await this.getReplenishmentInvoiceReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Replenishment Invoice Breakdown CSV Report
     */
    async getReplenishmentInvoiceReportBreakdownCsvRaw(requestParameters: GetReplenishmentInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getReplenishmentInvoiceReportBreakdownCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/replenishment-invoice-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Replenishment Invoice Breakdown CSV Report
     */
    async getReplenishmentInvoiceReportBreakdownCsv(requestParameters: GetReplenishmentInvoiceReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getReplenishmentInvoiceReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Replenishment Invoice Report Brief
     */
    async getReplenishmentInvoiceReportBriefRaw(requestParameters: GetReplenishmentInvoiceReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IInvoiceBriefRecordDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/replenishment-invoice-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IInvoiceBriefRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Replenishment Invoice Report Brief
     */
    async getReplenishmentInvoiceReportBrief(requestParameters: GetReplenishmentInvoiceReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IInvoiceBriefRecordDto> {
        const response = await this.getReplenishmentInvoiceReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Replenishment Invoice Report Summary
     */
    async getReplenishmentInvoiceReportSummaryRaw(requestParameters: GetReplenishmentInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSummaryPageDtoInvoiceSummaryRecordDto>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getReplenishmentInvoiceReportSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/replenishment-invoice-report/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSummaryPageDtoInvoiceSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Replenishment Invoice Report Summary
     */
    async getReplenishmentInvoiceReportSummary(requestParameters: GetReplenishmentInvoiceReportSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSummaryPageDtoInvoiceSummaryRecordDto> {
        const response = await this.getReplenishmentInvoiceReportSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Replenishment Invoice Report Summary CSV
     */
    async getReplenishmentInvoiceReportSummaryCsvRaw(requestParameters: GetReplenishmentInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employerId'] == null) {
            throw new runtime.RequiredError(
                'employerId',
                'Required parameter "employerId" was null or undefined when calling getReplenishmentInvoiceReportSummaryCsv().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['invoiceId'] != null) {
            queryParameters['invoice_id'] = requestParameters['invoiceId'];
        }

        if (requestParameters['invoiceCloseStartDate'] != null) {
            queryParameters['invoice_close_start_date'] = (requestParameters['invoiceCloseStartDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['invoiceCloseEndDate'] != null) {
            queryParameters['invoice_close_end_date'] = (requestParameters['invoiceCloseEndDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/replenishment-invoice-report/summary/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Replenishment Invoice Report Summary CSV
     */
    async getReplenishmentInvoiceReportSummaryCsv(requestParameters: GetReplenishmentInvoiceReportSummaryCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getReplenishmentInvoiceReportSummaryCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get CIP status Report Multi-Employers Summary
     */
    async getReportMultiEmployersSummaryRaw(requestParameters: GetReportMultiEmployersSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportMultiEmployersSummaryPageDtoCipStatusMultiEmployersSummaryRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/cip-status-report/multi-employers/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportMultiEmployersSummaryPageDtoCipStatusMultiEmployersSummaryRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get CIP status Report Multi-Employers Summary
     */
    async getReportMultiEmployersSummary(requestParameters: GetReportMultiEmployersSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportMultiEmployersSummaryPageDtoCipStatusMultiEmployersSummaryRecordDto> {
        const response = await this.getReportMultiEmployersSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Report Preferences
     */
    async getReportPreferencesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/preferences`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Get Report Preferences
     */
    async getReportPreferences(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getReportPreferencesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get Report Result page
     */
    async getReportResultPageRaw(requestParameters: GetReportResultPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageReportResultResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['startDateRange'] != null) {
            queryParameters['start_date_range'] = (requestParameters['startDateRange'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateRange'] != null) {
            queryParameters['end_date_range'] = (requestParameters['endDateRange'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['types'] != null) {
            queryParameters['types'] = requestParameters['types'];
        }

        if (requestParameters['groupTypes'] != null) {
            queryParameters['group_types'] = requestParameters['groupTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/results`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageReportResultResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get Report Result page
     */
    async getReportResultPage(requestParameters: GetReportResultPageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageReportResultResponseDto> {
        const response = await this.getReportResultPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Report Scheduler page
     */
    async getReportSchedulerPageRaw(requestParameters: GetReportSchedulerPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageReportSchedulerResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['startDateRange'] != null) {
            queryParameters['start_date_range'] = (requestParameters['startDateRange'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDateRange'] != null) {
            queryParameters['end_date_range'] = (requestParameters['endDateRange'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['types'] != null) {
            queryParameters['types'] = requestParameters['types'];
        }

        if (requestParameters['groupTypes'] != null) {
            queryParameters['group_types'] = requestParameters['groupTypes'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/schedulers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageReportSchedulerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get Report Scheduler page
     */
    async getReportSchedulerPage(requestParameters: GetReportSchedulerPageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageReportSchedulerResponseDto> {
        const response = await this.getReportSchedulerPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get total claim spend per plan for ER dashboard
     */
    async getTotalClaimSpendRaw(requestParameters: GetTotalClaimSpendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ITotalClaimSpendResponseDto>>> {
        if (requestParameters['planYearId'] == null) {
            throw new runtime.RequiredError(
                'planYearId',
                'Required parameter "planYearId" was null or undefined when calling getTotalClaimSpend().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['planYearId'] != null) {
            queryParameters['plan_year_id'] = requestParameters['planYearId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/account-usage/total-claim-spend`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ITotalClaimSpendResponseDtoFromJSON));
    }

    /**
     * Get total claim spend per plan for ER dashboard
     */
    async getTotalClaimSpend(requestParameters: GetTotalClaimSpendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ITotalClaimSpendResponseDto>> {
        const response = await this.getTotalClaimSpendRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get monthly claim spend breakdown by plan
     */
    async getTotalMonthlyClaimSpendBreakdownRaw(requestParameters: GetTotalMonthlyClaimSpendBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<INotionalPlanBalanceMonthlyBreakdownResponseDto>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling getTotalMonthlyClaimSpendBreakdown().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/account-usage/plans/{planId}/balances/notional`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => INotionalPlanBalanceMonthlyBreakdownResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get monthly claim spend breakdown by plan
     */
    async getTotalMonthlyClaimSpendBreakdown(requestParameters: GetTotalMonthlyClaimSpendBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<INotionalPlanBalanceMonthlyBreakdownResponseDto> {
        const response = await this.getTotalMonthlyClaimSpendBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Undeliverable Mail Report Breakdown
     */
    async getUndeliverableAddressReportBreakdownRaw(requestParameters: GetUndeliverableAddressReportBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportPageDtoUndeliverableAddressBreakdownRecordDto>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['employmentStatuses'] != null) {
            queryParameters['employment_statuses'] = requestParameters['employmentStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/undeliverable-address-report/breakdown`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportPageDtoUndeliverableAddressBreakdownRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Undeliverable Mail Report Breakdown
     */
    async getUndeliverableAddressReportBreakdown(requestParameters: GetUndeliverableAddressReportBreakdownRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportPageDtoUndeliverableAddressBreakdownRecordDto> {
        const response = await this.getUndeliverableAddressReportBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate Undeliverable Mail Report Breakdown CSV
     */
    async getUndeliverableAddressReportBreakdownCsvRaw(requestParameters: GetUndeliverableAddressReportBreakdownCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['employerId'] != null) {
            queryParameters['employer_id'] = requestParameters['employerId'];
        }

        if (requestParameters['employerIds'] != null) {
            queryParameters['employer_ids'] = requestParameters['employerIds'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['employmentStatuses'] != null) {
            queryParameters['employment_statuses'] = requestParameters['employmentStatuses'];
        }

        if (requestParameters['showSsn'] != null) {
            queryParameters['show_ssn'] = requestParameters['showSsn'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/undeliverable-address-report/breakdown/export/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate Undeliverable Mail Report Breakdown CSV
     */
    async getUndeliverableAddressReportBreakdownCsv(requestParameters: GetUndeliverableAddressReportBreakdownCsvRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getUndeliverableAddressReportBreakdownCsvRaw(requestParameters, initOverrides);
    }

    /**
     * Get Undeliverable Mail Report Brief
     */
    async getUndeliverableAddressReportBriefRaw(requestParameters: GetUndeliverableAddressReportBriefRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IUndeliverableAddressBriefRecordDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/undeliverable-address-report/brief`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IUndeliverableAddressBriefRecordDtoFromJSON(jsonValue));
    }

    /**
     * Get Undeliverable Mail Report Brief
     */
    async getUndeliverableAddressReportBrief(requestParameters: GetUndeliverableAddressReportBriefRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IUndeliverableAddressBriefRecordDto> {
        const response = await this.getUndeliverableAddressReportBriefRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get undeliverable mail metrics for ER dashboard
     */
    async getUndeliverableMailMetricsRaw(requestParameters: GetUndeliverableMailMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IUndeliverableMailMetricsResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['observedOrganizationPath'] != null) {
            headerParameters['Observed-Organization-Path'] = String(requestParameters['observedOrganizationPath']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/metrics/undeliverable-mail`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IUndeliverableMailMetricsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get undeliverable mail metrics for ER dashboard
     */
    async getUndeliverableMailMetrics(requestParameters: GetUndeliverableMailMetricsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IUndeliverableMailMetricsResponseDto> {
        const response = await this.getUndeliverableMailMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Report Scheduler
     */
    async updateReportSchedulerRaw(requestParameters: UpdateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IReportSchedulerResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateReportScheduler().'
            );
        }

        if (requestParameters['iReportSchedulerUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iReportSchedulerUpdateDto',
                'Required parameter "iReportSchedulerUpdateDto" was null or undefined when calling updateReportScheduler().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/schedulers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IReportSchedulerUpdateDtoToJSON(requestParameters['iReportSchedulerUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IReportSchedulerResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update Report Scheduler
     */
    async updateReportScheduler(requestParameters: UpdateReportSchedulerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IReportSchedulerResponseDto> {
        const response = await this.updateReportSchedulerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert Report Preferences
     */
    async upsertReportPreferencesRaw(requestParameters: UpsertReportPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling upsertReportPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/reports/preferences`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Upsert Report Preferences
     */
    async upsertReportPreferences(requestParameters: UpsertReportPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.upsertReportPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetCardStatusMultiEmployerSummaryCardStatusReportGroupTypeEnum {
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCardStatusMultiEmployerSummaryCsvCardStatusReportGroupTypeEnum {
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCardStatusReportBreakdownCardStatusesEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    LOST = 'LOST',
    PENDING_OPEN = 'PENDING_OPEN',
    PENDING_FROZEN = 'PENDING_FROZEN',
    PENDING_REPLACE = 'PENDING_REPLACE',
    STOLEN = 'STOLEN',
    NOT_SENT = 'NOT_SENT',
    PENDING_UNLOCK = 'PENDING_UNLOCK',
    DAMAGED = 'DAMAGED',
    CLOSING = 'CLOSING',
    DEMOGRAPHIC_CHANGE = 'DEMOGRAPHIC_CHANGE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCardStatusReportBreakdownEmploymentStatusesEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCardStatusReportBreakdownCsvCardStatusesEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    LOST = 'LOST',
    PENDING_OPEN = 'PENDING_OPEN',
    PENDING_FROZEN = 'PENDING_FROZEN',
    PENDING_REPLACE = 'PENDING_REPLACE',
    STOLEN = 'STOLEN',
    NOT_SENT = 'NOT_SENT',
    PENDING_UNLOCK = 'PENDING_UNLOCK',
    DAMAGED = 'DAMAGED',
    CLOSING = 'CLOSING',
    DEMOGRAPHIC_CHANGE = 'DEMOGRAPHIC_CHANGE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCardStatusReportBreakdownCsvEmploymentStatusesEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCardStatusReportSummaryCardStatusReportGroupTypeEnum {
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCardStatusReportSummaryCsvCardStatusReportGroupTypeEnum {
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCipStatusReportBreakdownEmploymentStatusesEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCipStatusReportBreakdownAccountStatusesEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCipStatusReportBreakdownEnrollmentStatusesEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCipStatusReportBreakdownCipStatusesEnum {
    NONE = 'NONE',
    PENDING = 'PENDING',
    PASS = 'PASS',
    FAIL = 'FAIL',
    QUESTION = 'QUESTION',
    RENEWED = 'RENEWED',
    CIP_FAILED_ACCOUNT_CLOSE = 'CIP_FAILED_ACCOUNT_CLOSE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCipStatusReportBreakdownCsvEmploymentStatusesEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCipStatusReportBreakdownCsvAccountStatusesEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCipStatusReportBreakdownCsvEnrollmentStatusesEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetCipStatusReportBreakdownCsvCipStatusesEnum {
    NONE = 'NONE',
    PENDING = 'PENDING',
    PASS = 'PASS',
    FAIL = 'FAIL',
    QUESTION = 'QUESTION',
    RENEWED = 'RENEWED',
    CIP_FAILED_ACCOUNT_CLOSE = 'CIP_FAILED_ACCOUNT_CLOSE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityMultiEmployerSummaryClaimStatusesEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityMultiEmployerSummaryClaimTypesEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityMultiEmployerSummaryCsvClaimStatusesEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityMultiEmployerSummaryCsvClaimTypesEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityReportBreakdownClaimTypesEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityReportBreakdownClaimStatusesEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityReportBreakdownCsvClaimTypesEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityReportBreakdownCsvClaimStatusesEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityReportSummaryClaimStatusesEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityReportSummaryClaimTypesEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityReportSummaryCsvClaimStatusesEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetClaimActivityReportSummaryCsvClaimTypesEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsMultiEmployerSummaryAccountTypesEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsMultiEmployerSummaryPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsMultiEmployerSummaryCsvAccountTypesEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsMultiEmployerSummaryCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportBreakdownDelinquentClaimsViewTypeEnum {
    BY_EMPLOYEE = 'BY_EMPLOYEE',
    BY_CLAIM = 'BY_CLAIM'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportBreakdownPlanYearPeriodsEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportBreakdownAccountTypesEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportBreakdownClaimStatusesEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportBreakdownCsvDelinquentClaimsViewTypeEnum {
    BY_EMPLOYEE = 'BY_EMPLOYEE',
    BY_CLAIM = 'BY_CLAIM'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportBreakdownCsvPlanYearPeriodsEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportBreakdownCsvAccountTypesEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportBreakdownCsvClaimStatusesEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportSummaryPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportSummaryAccountTypesEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportSummaryCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetDelinquentClaimsReportSummaryCsvAccountTypesEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEmployeeDemographicsReportBreakdownEmploymentStatusesEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEmployeeDemographicsReportBreakdownCsvEmploymentStatusesEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum GetEmployerCalendarEventsCategoriesEnum {
    PLAN_DATES = 'PLAN_DATES',
    FUNDING = 'FUNDING'
}
/**
  * @export
  * @enum {string}
  */
export enum GetForfeitureReportBreakdownForfeitureReportGroupEnum {
    EMPLOYEE = 'EMPLOYEE',
    TRANSACTION = 'TRANSACTION'
}
/**
  * @export
  * @enum {string}
  */
export enum GetForfeitureReportBreakdownPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetForfeitureReportBreakdownCsvForfeitureReportGroupEnum {
    EMPLOYEE = 'EMPLOYEE',
    TRANSACTION = 'TRANSACTION'
}
/**
  * @export
  * @enum {string}
  */
export enum GetForfeitureReportBreakdownCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetForfeitureReportSummaryPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetForfeitureReportSummaryCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetHealthPlanEnrollmentReportBreakdownPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetHealthPlanEnrollmentReportBreakdownCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetHealthPlanEnrollmentReportSummaryPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetHealthPlanEnrollmentReportSummaryCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPaaMultiEmployerSummaryPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPaaMultiEmployerSummaryCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetParticipantAccountActivityReportBreakdownPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetParticipantAccountActivityReportBreakdownEnrollmentStatusesEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetParticipantAccountActivityReportBreakdownAccountTypesEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetParticipantAccountActivityReportBreakdownCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetParticipantAccountActivityReportBreakdownCsvEnrollmentStatusesEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetParticipantAccountActivityReportBreakdownCsvAccountTypesEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
  * @export
  * @enum {string}
  */
export enum GetParticipantAccountActivityReportSummaryPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetParticipantAccountActivityReportSummaryCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPayrollContributionsMultiEmployerSummaryPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPayrollContributionsMultiEmployerSummaryCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPayrollContributionsReportSummaryPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPayrollContributionsReportSummaryCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPlanOmnibusBalanceReportSummaryPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetPlanOmnibusBalanceReportSummaryCsvPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
  * @export
  * @enum {string}
  */
export enum GetReportResultPageTypesEnum {
    PARTICIPANT_ACCOUNT_ACTIVITY = 'PARTICIPANT_ACCOUNT_ACTIVITY',
    PAYROLL_CONTRIBUTIONS = 'PAYROLL_CONTRIBUTIONS',
    EMPLOYEE_DEMOGRAPHICS = 'EMPLOYEE_DEMOGRAPHICS',
    CLAIM_ACTIVITY = 'CLAIM_ACTIVITY',
    FORFEITURE = 'FORFEITURE',
    HEALTH_PLAN_ENROLLMENT = 'HEALTH_PLAN_ENROLLMENT',
    CARD_STATUS = 'CARD_STATUS',
    CIP_STATUS = 'CIP_STATUS',
    REPLENISHMENT_INVOICE = 'REPLENISHMENT_INVOICE',
    CONTRIBUTION_INVOICE = 'CONTRIBUTION_INVOICE',
    PREFUND_INVOICE = 'PREFUND_INVOICE',
    PLAN_OMNIBUS_BALANCE = 'PLAN_OMNIBUS_BALANCE',
    UNDELIVERABLE_ADDRESS = 'UNDELIVERABLE_ADDRESS',
    DELINQUENT_CLAIMS = 'DELINQUENT_CLAIMS'
}
/**
  * @export
  * @enum {string}
  */
export enum GetReportResultPageGroupTypesEnum {
    SUMMARY = 'SUMMARY',
    BREAKDOWN = 'BREAKDOWN'
}
/**
  * @export
  * @enum {string}
  */
export enum GetReportSchedulerPageTypesEnum {
    PARTICIPANT_ACCOUNT_ACTIVITY = 'PARTICIPANT_ACCOUNT_ACTIVITY',
    PAYROLL_CONTRIBUTIONS = 'PAYROLL_CONTRIBUTIONS',
    EMPLOYEE_DEMOGRAPHICS = 'EMPLOYEE_DEMOGRAPHICS',
    CLAIM_ACTIVITY = 'CLAIM_ACTIVITY',
    FORFEITURE = 'FORFEITURE',
    HEALTH_PLAN_ENROLLMENT = 'HEALTH_PLAN_ENROLLMENT',
    CARD_STATUS = 'CARD_STATUS',
    CIP_STATUS = 'CIP_STATUS',
    REPLENISHMENT_INVOICE = 'REPLENISHMENT_INVOICE',
    CONTRIBUTION_INVOICE = 'CONTRIBUTION_INVOICE',
    PREFUND_INVOICE = 'PREFUND_INVOICE',
    PLAN_OMNIBUS_BALANCE = 'PLAN_OMNIBUS_BALANCE',
    UNDELIVERABLE_ADDRESS = 'UNDELIVERABLE_ADDRESS',
    DELINQUENT_CLAIMS = 'DELINQUENT_CLAIMS'
}
/**
  * @export
  * @enum {string}
  */
export enum GetReportSchedulerPageGroupTypesEnum {
    SUMMARY = 'SUMMARY',
    BREAKDOWN = 'BREAKDOWN'
}
/**
  * @export
  * @enum {string}
  */
export enum GetReportSchedulerPageStatusesEnum {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED'
}
/**
  * @export
  * @enum {string}
  */
export enum GetUndeliverableAddressReportBreakdownEmploymentStatusesEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
  * @export
  * @enum {string}
  */
export enum GetUndeliverableAddressReportBreakdownCsvEmploymentStatusesEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
